/* eslint-disable no-unused-vars, no-loop-func, jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./App.css";
import { db, ref } from "./firebase";
import {
  get,
  set,
  remove,
  onValue,
  update
} from "firebase/database";
import Papa from "papaparse";
import Select from "react-select";
import { Analytics } from "@vercel/analytics/react";

function getPrayerTimesLookupDate(date, usePreviousYear) {
  if (!usePreviousYear || date.getFullYear() !== 2026) {
    return date;
  }
  const lookup = new Date(date);
  lookup.setFullYear(2025);
  return lookup;
}

function Header({ theme, setTheme, timeFormat, setTimeFormat, layout, setLayout }) {

  const scrollToHijriCalendar = () => {
    const calendarElement = document.getElementById('hijri-calendar');
    if (calendarElement) {
      calendarElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1 className="header-title">Salah Times | தொழுகை நேரங்கள்</h1>
        <span className="flag-icon">🇱🇰</span>
      </div>

      <div className="header-toggles">
        <div className="toggle-buttons-group">
          <div className="layout-toggle">
            <button
              className={`round-toggle-btn ${layout === "horizontal" ? "active" : "inactive"}`}
              onClick={() => setLayout("horizontal")}
              aria-label="Horizontal layout"
              title="Horizontal Layout"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
              </svg>
            </button>
            <button
              className={`round-toggle-btn ${layout === "grid" ? "active" : "inactive"}`}
              onClick={() => setLayout("grid")}
              aria-label="Grid layout"
              title="Grid Layout (3x2)"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z" />
              </svg>
            </button>
          </div>

          <div className="time-format-toggle">
            <button
              className={`round-toggle-btn ${timeFormat === "12h" ? "active" : "inactive"}`}
              onClick={() => setTimeFormat("12h")}
              aria-label="12 hour format"
            >
              12h
            </button>
            <button
              className={`round-toggle-btn ${timeFormat === "24h" ? "active" : "inactive"}`}
              onClick={() => setTimeFormat("24h")}
              aria-label="24 hour format"
            >
              24h
            </button>
          </div>

          <div className="theme-toggle">
            <button
              className={`round-toggle-btn ${theme === "light" ? "active" : "inactive"}`}
              onClick={() => setTheme("light")}
              aria-label="Light mode"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
              </svg>
            </button>
            <button
              className={`round-toggle-btn ${theme === "dark" ? "active" : "inactive"}`}
              onClick={() => setTheme("dark")}
              aria-label="Dark mode"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z" />
              </svg>
            </button>
          </div>
        </div>

        <button
          className="calendar-scroll-btn"
          onClick={scrollToHijriCalendar}
          title="View Hijri Calendar"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
          </svg>
          <span>Hijri Calendar</span>
        </button>
      </div>
    </header>
  );
}

function DateNavigator({ selectedDate, setSelectedDate }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const [hijriDate, setHijriDate] = useState("");
  const [currentMonth, setCurrentMonth] = useState(new Date(selectedDate));

  // Format date for display (e.g., "08 May")
  const formatDisplayDate = (date) => {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short'
    });
  };

  // Format date for Firebase key (e.g., "190725" for 19 Jul 2025)
  const formatFirebaseKey = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${day}${month}${year}`;
  };

  const formatFirebaseKeyYYMMDD = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${year}${month}${day}`;
  };

  // Navigate to previous day
  const goToPreviousDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() - 1);
    setSelectedDate(newDate);
  };

  // Navigate to next day
  const goToNextDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() + 1);
    setSelectedDate(newDate);
  };

  // Navigate to previous month
  const goToPreviousMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() - 1);
    setCurrentMonth(newMonth);
  };

  // Navigate to next month
  const goToNextMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() + 1);
    setCurrentMonth(newMonth);
  };

  // Handle today button click
  const handleTodayClick = () => {
    setSelectedDate(new Date());
  };

  // Handle calendar date selection
  const handleDateSelect = (day) => {
    const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    setSelectedDate(newDate);
    setShowCalendar(false);
  };

  // Generate calendar days
  const generateCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const days = [];
    const today = new Date();

    for (let i = 0; i < 42; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);

      const isCurrentMonth = date.getMonth() === month;
      const isSelected = date.toDateString() === selectedDate.toDateString();
      const isToday = date.toDateString() === today.toDateString();

      days.push({
        day: date.getDate(),
        isCurrentMonth,
        isSelected,
        isToday,
        date
      });
    }

    return days;
  };

  // Fetch Hijri date from Firebase
  useEffect(() => {
    const firebaseKey = formatFirebaseKey(selectedDate);
    const metaRef = ref(db, `meta/${firebaseKey}/LK`);
    let unsubscribeAlt = null;

    const unsubscribe = onValue(metaRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.dayHijri && data.monthHijri && data.yearHijri) {
        const hijriString = `${data.dayHijri} ${data.monthHijri}, ${data.yearHijri}`;
        setHijriDate(hijriString);
        if (unsubscribeAlt) {
          unsubscribeAlt();
          unsubscribeAlt = null;
        }
      } else {
        const firebaseKeyAlt = formatFirebaseKeyYYMMDD(selectedDate);
        const metaRefAlt = ref(db, `meta/${firebaseKeyAlt}/LK`);

        if (!unsubscribeAlt) {
          unsubscribeAlt = onValue(metaRefAlt, (snapshotAlt) => {
            const dataAlt = snapshotAlt.val();
            if (dataAlt && dataAlt.dayHijri && dataAlt.monthHijri && dataAlt.yearHijri) {
              const hijriString = `${dataAlt.dayHijri} ${dataAlt.monthHijri}, ${dataAlt.yearHijri}`;
              setHijriDate(hijriString);
            } else {
              setHijriDate("No data found.");
            }
          }, (error) => {
            console.error("Error fetching alternate Hijri date:", error);
            setHijriDate("No data found.");
          });
        }
      }
    }, (error) => {
      console.error("Error fetching Hijri date:", error);
      setHijriDate("No data found.");
    });

    return () => {
      unsubscribe();
      if (unsubscribeAlt) unsubscribeAlt();
    };
  }, [selectedDate]);

  const calendarDays = generateCalendarDays();

  return (
    <>
      <div className="date-navigator">
        <button onClick={goToPreviousDay}>{"<"}</button>
        <span
          onClick={() => setShowCalendar(true)}
          style={{ cursor: 'pointer', userSelect: 'none' }}
          title="Click to select date"
        >
          {formatDisplayDate(selectedDate)}
        </span>
        <button onClick={goToNextDay}>{">"}</button>
        <button onClick={handleTodayClick} className="today-btn" title="Go to Today">
          <span role="img" aria-label="today">📅</span>
        </button>
        <span className="hijri-date">{hijriDate}</span>
      </div>

      {showCalendar && (
        <div className="modal-overlay" onClick={() => setShowCalendar(false)}>
          <div className="modal-content calendar-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Select Date</h2>
              <button className="modal-close" onClick={() => setShowCalendar(false)}>×</button>
            </div>
            <div className="calendar-container">
              <div className="calendar-header">
                <button onClick={goToPreviousMonth}>{"<"}</button>
                <span>{currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</span>
                <button onClick={goToNextMonth}>{">"}</button>
              </div>
              <div className="calendar-weekdays">
                {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map(day => (
                  <div key={day} className="weekday">{day}</div>
                ))}
              </div>
              <div className="calendar-days">
                {calendarDays.map((day, index) => (
                  <button
                    key={index}
                    className={`calendar-day ${!day.isCurrentMonth ? 'other-month' : ''} ${day.isSelected ? 'selected' : ''} ${day.isToday ? 'today' : ''}`}
                    onClick={() => day.isCurrentMonth && handleDateSelect(day.day)}
                    disabled={!day.isCurrentMonth}
                  >
                    {day.day}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function PrayerTimesCard({ selectedArea, selectedDate, prayerTimes, setPrayerTimes, isLoading, setIsLoading, setSelectedArea, setSelectedDate, timeFormat, layout }) {
  const [zoneData, setZoneData] = useState(null);
  const [areas, setAreas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [zones, setZones] = useState([]);
  const [usePreviousYear, setUsePreviousYear] = useState(true);

  useEffect(() => {
    const settingsRef = ref(db, "settings/usePreviousYearForPrayerTimes");
    const unsubscribe = onValue(settingsRef, (snapshot) => {
      const value = snapshot.val();
      setUsePreviousYear(value !== false);
    });
    return () => unsubscribe();
  }, []);

  // Fetch areas for lookup
  useEffect(() => {
    const areasRef = ref(db, "zones/areas");
    const unsubscribe = onValue(areasRef, (snapshot) => {
      const data = snapshot.val() || {};
      const areasList = Object.entries(data).map(([key, name]) => ({ key, name }));
      setAreas(areasList);
    });
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch zones for modal
  useEffect(() => {
    const zonesRef = ref(db, "zones");
    const unsubscribe = onValue(zonesRef, (snapshot) => {
      const data = snapshot.val() || {};
      const zonesList = [];

      Object.entries(data).forEach(([key, zoneData]) => {
        if (key !== "areas") {
          zonesList.push({
            key,
            title: zoneData.title || key,
            areas: zoneData.areas || []
          });
        }
      });

      // Sort zones by title
      zonesList.sort((a, b) => a.title.localeCompare(b.title));
      setZones(zonesList);

      // Set first zone's first area as default if none selected and no saved area
      if (zonesList.length > 0 && !selectedArea) {
        const savedArea = localStorage.getItem('selectedArea');
        if (savedArea) {
          // Check if saved area still exists in zones
          const areaExists = zonesList.some(zone => zone.areas.includes(savedArea));
          if (areaExists) {
            setSelectedArea(savedArea);
          } else {
            // Saved area no longer exists, use first available
            const firstZone = zonesList[0];
            if (firstZone.areas.length > 0) {
              setSelectedArea(firstZone.areas[0]);
            }
          }
        } else {
          // No saved area, use first available
          const firstZone = zonesList[0];
          if (firstZone.areas.length > 0) {
            setSelectedArea(firstZone.areas[0]);
          }
        }
      }
    });
    return () => unsubscribe();
  }, [selectedArea, setSelectedArea]);

  // Find zone that contains the selected area
  useEffect(() => {
    if (!selectedArea) return;

    const zonesRef = ref(db, "zones");
    const unsubscribe = onValue(zonesRef, (snapshot) => {
      const data = snapshot.val() || {};
      let foundZone = null;

      Object.entries(data).forEach(([zoneKey, zoneData]) => {
        if (zoneKey !== "areas" && zoneData.areas) {
          const areaKeys = Object.values(zoneData.areas);
          if (areaKeys.includes(selectedArea)) {
            foundZone = {
              key: zoneKey,
              title: zoneData.title || "",
              areas: areaKeys
            };
          }
        }
      });

      setZoneData(foundZone);
    });
    return () => unsubscribe();
  }, [selectedArea]);

  // Fetch prayer times from Firebase
  useEffect(() => {
    if (!selectedDate || !zoneData) return;

    setIsLoading(true);

    const lookupDate = getPrayerTimesLookupDate(selectedDate, usePreviousYear);
    const day = lookupDate.getDate().toString().padStart(2, '0');
    const month = (lookupDate.getMonth() + 1).toString().padStart(2, '0');
    const year = lookupDate.getFullYear().toString().slice(-2);
    const dateKey = `${day}${month}${year}`;
    const dateKeyAlt = `${year}${month}${day}`;
    const trimmedZoneKey = zoneData.key.trim();

    const prayerTimesRef = ref(db, `prayerTimes/${dateKey}/LK/${trimmedZoneKey}`);
    let unsubscribeAlt = null;

    const unsubscribe = onValue(prayerTimesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setPrayerTimes(data);
        // Make prayer times available globally for image generation
        window.currentPrayerTimes = data;
        setIsLoading(false);
        if (unsubscribeAlt) {
          unsubscribeAlt();
          unsubscribeAlt = null;
        }
      } else {
        const prayerTimesRefAlt = ref(db, `prayerTimes/${dateKeyAlt}/LK/${trimmedZoneKey}`);
        if (!unsubscribeAlt) {
          unsubscribeAlt = onValue(prayerTimesRefAlt, (snapshotAlt) => {
            const dataAlt = snapshotAlt.val();
            if (dataAlt) {
              setPrayerTimes(dataAlt);
              window.currentPrayerTimes = dataAlt;
            } else {
              setPrayerTimes({});
              window.currentPrayerTimes = {};
            }
            setIsLoading(false);
          }, (error) => {
            console.error("Error fetching alternate prayer times:", error);
            setPrayerTimes({});
            window.currentPrayerTimes = {};
            setIsLoading(false);
          });
        }
      }
    }, (error) => {
      console.error("Error fetching prayer times:", error);
      setPrayerTimes({});
      window.currentPrayerTimes = {};
      setIsLoading(false);
    });

    return () => {
      unsubscribe();
      if (unsubscribeAlt) unsubscribeAlt();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, zoneData, usePreviousYear]);

  // Get area names for display
  const getAreaNames = () => {
    if (!zoneData || !zoneData.areas) return "";

    const areaNames = zoneData.areas
      .map(areaKey => {
        const area = areas.find(a => a.key === areaKey);
        return area ? area.name : areaKey;
      })
      .map(name => name.replace(" District", "")); // Remove "District" from each name

    if (areaNames.length === 0) return "";
    if (areaNames.length === 1) return `${areaNames[0]} District`;
    if (areaNames.length === 2) return `${areaNames[0]} & ${areaNames[1]} District`;

    // For 3 or more areas: "Colombo, Gampaha & Kalutara District"
    const lastArea = areaNames.pop();
    return `${areaNames.join(", ")} & ${lastArea} District`;
  };

  // Helper function to get prayer time
  const getPrayerTime = (prayerName) => {
    const prayerData = prayerTimes[prayerName.toLowerCase()];
    if (prayerData && prayerData.h !== null && prayerData.m !== null) {
      if (timeFormat === "12h") {
        // Convert to 12-hour format
        let hour = prayerData.h;
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour === 0 ? 12 : hour;
        return {
          hour: hour.toString().padStart(2, '0'),
          minute: prayerData.m.toString().padStart(2, '0'),
          ampm: ampm
        };
      } else {
        // 24-hour format
        return {
          hour: prayerData.h.toString().padStart(2, '0'),
          minute: prayerData.m.toString().padStart(2, '0'),
          ampm: null
        };
      }
    }
    return { hour: '--', minute: '--', ampm: null };
  };

  // Helper function to check if prayer is current
  const isCurrentPrayer = (prayerKey) => {
    if (!prayerTimes || Object.keys(prayerTimes).length === 0) return false;

    const prayerOrder = ['fajr', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'];
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentTimeInMinutes = currentHour * 60 + currentMinute;

    // Find current prayer
    for (let i = 0; i < prayerOrder.length; i++) {
      const prayerData = prayerTimes[prayerOrder[i]];
      if (prayerData && prayerData.h !== null && prayerData.m !== null) {
        const prayerTimeInMinutes = prayerData.h * 60 + prayerData.m;

        // Check if this prayer time has passed and next prayer hasn't started yet
        if (prayerTimeInMinutes <= currentTimeInMinutes) {
          // If this is the last prayer of the day, it's current until next day
          if (i === prayerOrder.length - 1) {
            return prayerOrder[i] === prayerKey;
          }

          // Check if next prayer hasn't started yet
          const nextPrayerData = prayerTimes[prayerOrder[i + 1]];
          if (nextPrayerData && nextPrayerData.h !== null && nextPrayerData.m !== null) {
            const nextPrayerTimeInMinutes = nextPrayerData.h * 60 + nextPrayerData.m;
            if (currentTimeInMinutes < nextPrayerTimeInMinutes) {
              return prayerOrder[i] === prayerKey;
            }
          }
        }
      }
    }

    return false;
  };

  // Filter zones based on search term
  const filteredZones = zones.filter(zone => {
    const zoneTitle = zone.title.toLowerCase();
    const areaNames = zone.areas
      .map(areaKey => areas.find(a => a.key === areaKey)?.name || areaKey)
      .join(' ')
      .toLowerCase();

    return zoneTitle.includes(searchTerm.toLowerCase()) ||
      areaNames.includes(searchTerm.toLowerCase());
  });

  // Handle zone selection
  const handleZoneSelect = (zone) => {
    if (zone.areas.length > 0) {
      const selectedAreaKey = zone.areas[0];
      setSelectedArea(selectedAreaKey);
      setSelectedDate(new Date()); // Reset to today

      // Save selected area to localStorage
      localStorage.setItem('selectedArea', selectedAreaKey);
    }
    setShowModal(false);
    setSearchTerm("");
  };

  return (
    <>
      <div className="prayer-times-card">
        <div className="zone-header" onClick={() => setShowModal(true)}>
          <div className="zone-title">{zoneData ? zoneData.title : "Loading..."}</div>
          <div className="zone-change-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
            </svg>
            <span className="change-caption">Change / மாற்று</span>
          </div>
        </div>
        <div className="zone-areas">{getAreaNames()}</div>
        <DateNavigator selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        <div className={`prayer-times-grid ${layout === "grid" ? "prayer-times-grid-3x2" : ""}`}>
          {[
            { name: 'SUBAH', icon: 'subah.svg', tamilName: 'சுபஹ்', key: 'fajr' },
            { name: 'SUNRISE', icon: 'sunrise.svg', tamilName: 'சூரிய உதயம்', key: 'sunrise' },
            { name: 'LUHAR', icon: 'luhar.svg', tamilName: 'லுஹர்', key: 'luhar' },
            { name: 'ASR', icon: 'asr.svg', tamilName: 'அஸர்', key: 'asr' },
            { name: 'MAGHRIB', icon: 'maghrib.svg', tamilName: 'மஃரிப்', key: 'maghrib' },
            { name: 'ISHA', icon: 'isha.svg', tamilName: 'இஷா', key: 'isha' }
          ].map((prayer) => {
            const time = getPrayerTime(prayer.key);
            const isCurrent = isCurrentPrayer(prayer.key);
            return (
              <div className={`prayer-time-card ${isCurrent ? 'current-prayer' : ''} ${layout === "grid" ? "prayer-time-card-grid" : ""}`} key={prayer.name}>
                <div className="prayer-icon">
                  <img
                    src={`/${prayer.icon}`}
                    alt={prayer.name}
                    style={{
                      filter: isCurrent ? 'brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(638%) hue-rotate(359deg) brightness(103%) contrast(107%)' : 'brightness(0) invert(1)'
                    }} // Makes SVG yellow for current prayer, white for others
                  />
                </div>
                <div className="prayer-tamil-name">{prayer.tamilName}</div>
                <div className="prayer-english-name">{prayer.name}</div>
                <div className="prayer-time-display">
                  {isLoading ? (
                    <div className="loading-spinner">
                      <div className="spinner"></div>
                    </div>
                  ) : (
                    <>
                      <div className="prayer-hour">{time.hour}</div>
                      <div className="prayer-minute">{time.minute}</div>
                      {time.ampm && <div className="prayer-ampm">{time.ampm}</div>}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {showModal && (
        <div className="district-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="district-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                <span className="globe-icon">🌐</span>
                Select Zone
              </h3>
              <button
                className="modal-close"
                onClick={() => setShowModal(false)}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            <div className="modal-search">
              <input
                type="text"
                placeholder="Search zones or areas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="modal-search-input"
                autoFocus
              />
            </div>

            <div className="modal-content">
              {filteredZones.length === 0 ? (
                <div className="no-results">
                  <div className="no-results-icon">🔍</div>
                  <div className="no-results-text">No zones found</div>
                </div>
              ) : (
                filteredZones.map(zone => {
                  const zoneAreaNames = zone.areas
                    .map(areaKey => areas.find(a => a.key === areaKey)?.name || areaKey)
                    .map(name => name.replace(" District", ""));

                  return (
                    <div
                      key={zone.key}
                      className={`zone-option ${zone.areas.includes(selectedArea) ? 'selected' : ''}`}
                      onClick={() => handleZoneSelect(zone)}
                    >
                      <div className="zone-title">{zone.title}</div>
                      <div className="zone-areas-list">
                        {zoneAreaNames.length === 0 ? "" :
                          zoneAreaNames.length === 1 ? `${zoneAreaNames[0]} District` :
                            zoneAreaNames.length === 2 ? `${zoneAreaNames[0]} & ${zoneAreaNames[1]} District` :
                              `${zoneAreaNames.slice(0, -1).join(", ")} & ${zoneAreaNames[zoneAreaNames.length - 1]} District`}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function FloatingShareButton() {
  const [showMenu, setShowMenu] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  // Function to construct prayer times text message
  const constructPrayerTimesMessage = () => {
    // Get current data from DOM
    const zoneTitle = document.querySelector('.zone-title')?.textContent || 'Prayer Times';
    const zoneAreas = document.querySelector('.zone-areas')?.textContent || '';
    const dateDisplay = document.querySelector('.date-navigator span')?.textContent || '';
    const hijriDate = document.querySelector('.hijri-date')?.textContent || '';

    // Get prayer times from DOM
    const prayerCards = document.querySelectorAll('.prayer-time-card');
    const prayerTimesData = {};

    prayerCards.forEach(card => {
      const englishName = card.querySelector('.prayer-english-name')?.textContent;
      const timeHour = card.querySelector('.prayer-hour')?.textContent;
      const timeMinute = card.querySelector('.prayer-minute')?.textContent;
      const timeAmpm = card.querySelector('.prayer-ampm')?.textContent || '';

      if (englishName && timeHour && timeMinute) {
        const prayerKey = englishName.toLowerCase();
        prayerTimesData[prayerKey] = {
          name: englishName,
          time: `${timeHour}:${timeMinute}${timeAmpm ? ` ${timeAmpm}` : ''}`
        };
      }
    });

    // Map prayer names to display names
    const prayerDisplayNames = {
      'subah': 'Fajr',
      'sunrise': 'Sunrise',
      'luhar': 'Luhar',
      'asr': 'Asr',
      'maghrib': 'Maghrib',
      'isha': 'Isha'
    };

    // Construct the message
    let message = `🕌 Prayer Times\n\n`;
    message += `📅 Date: ${dateDisplay}\n`;
    message += `📅 Hijri: ${hijriDate}\n\n`;
    message += `📍 Zone: ${zoneTitle}\n`;
    message += `📍 Areas: ${zoneAreas}\n\n`;
    message += `⏰ Prayer Times:\n`;

    // Add prayer times
    const prayerOrder = ['subah', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'];
    prayerOrder.forEach(prayerKey => {
      const prayerData = prayerTimesData[prayerKey] || prayerTimesData[prayerDisplayNames[prayerKey]?.toLowerCase()];
      if (prayerData) {
        message += `• ${prayerDisplayNames[prayerKey] || prayerKey.toUpperCase()}: ${prayerData.time}\n`;
      }
    });

    message += `\n📱 Sent from SalahTimes (www.salahtimes.vip)\n`;
    message += `💡 Tip: You can change your zone to benefit from accurate prayer times for your location.`;

    return message;
  };

  const generatePrayerTimesImage = async () => {
    try {
      // Create a temporary container for the image
      const tempContainer = document.createElement('div');
      tempContainer.style.cssText = `
        position: fixed;
        top: -9999px;
        left: -9999px;
        width: 400px;
        background: #f7fafd;
        border-radius: 20px;
        padding: 0;
        font-family: 'Inter', Arial, sans-serif;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
        overflow: hidden;
      `;

      // Get current prayer times data
      const prayerTimesCard = document.querySelector('.prayer-times-card');
      if (!prayerTimesCard) {
        alert('Prayer times not available');
        return;
      }

      // Helper function to get SVG icon content
      const getPrayerIconSVG = async (prayerKey) => {
        const iconMap = {
          'subah': 'subah.svg',
          'sunrise': 'sunrise.svg',
          'luhar': 'luhar.svg',
          'asr': 'asr.svg',
          'maghrib': 'maghrib.svg',
          'isha': 'isha.svg'
        };

        const iconFile = iconMap[prayerKey] || 'subah.svg';
        try {
          const response = await fetch(`/${iconFile}`);
          const svgContent = await response.text();
          return svgContent;
        } catch (error) {
          console.error('Error loading SVG:', error);
          return '🌙'; // Fallback to emoji
        }
      };

      // Get zone and date info
      const zoneTitle = document.querySelector('.zone-title')?.textContent || 'Prayer Times';
      const zoneAreas = document.querySelector('.zone-areas')?.textContent || '';
      const dateDisplay = document.querySelector('.date-navigator span')?.textContent || '';
      const hijriDate = document.querySelector('.hijri-date')?.textContent || '';

      // Get actual prayer times from the DOM
      const prayerCards = document.querySelectorAll('.prayer-time-card');
      const prayerTimesData = {};

      prayerCards.forEach(card => {
        const englishName = card.querySelector('.prayer-english-name')?.textContent;
        const timeHour = card.querySelector('.prayer-hour')?.textContent;
        const timeMinute = card.querySelector('.prayer-minute')?.textContent;

        if (englishName && timeHour && timeMinute) {
          const prayerKey = englishName.toLowerCase();
          prayerTimesData[prayerKey] = {
            name: englishName,
            time: `${timeHour}:${timeMinute}`
          };
        }
      });

      // Load SVG icons for all prayers
      const prayerIcons = {};
      const prayerKeys = ['subah', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'];

      for (const key of prayerKeys) {
        prayerIcons[key] = await getPrayerIconSVG(key);
      }

      // Create the image content
      tempContainer.innerHTML = `
        <div style="
          background: #ffc85a;
          color: #333;
          padding: 15px 20px;
          border-radius: 20px 20px 0 0;
          font-weight: bold;
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <div>
            <div style="font-size: 14px; margin-bottom: 2px;">${zoneTitle}</div>
            <div style="font-size: 12px; opacity: 0.8;">${zoneAreas}</div>
          </div>
          <div style="
            font-size: 24px;
            margin-right: 5px;
          ">🇱🇰</div>
        </div>
        <div style="
          background: #fff;
          border-radius: 16px;
          padding: 1rem;
          margin: 1rem;
          text-align: center;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        ">
          <div style="
            font-size: 1.4rem;
            font-weight: bold;
            color: #333;
            margin-bottom: 0.3rem;
          ">
            ${dateDisplay}
          </div>
          <div style="
            font-size: 0.9rem;
            color: #4182a4;
          ">
            ${hijriDate}
          </div>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          gap: 0.4rem;
          flex-wrap: nowrap;
          overflow: visible;
          padding: 0 1rem 1rem 1rem;
        ">
          ${[
          { key: 'subah', en: 'SUBAH', ta: 'சுபஹ்' },
          { key: 'sunrise', en: 'SUNRISE', ta: 'சூரிய உதயம்' },
          { key: 'luhar', en: 'LUHAR', ta: 'லுஹர்' },
          { key: 'asr', en: 'ASR', ta: 'அஸர்' },
          { key: 'maghrib', en: 'MAGHRIB', ta: 'மஃரிப்' },
          { key: 'isha', en: 'ISHA', ta: 'இஷா' }
        ].map(prayer => {
          const prayerData = prayerTimesData[prayer.key] || prayerTimesData[prayer.en.toLowerCase()];
          const time = prayerData ? prayerData.time : '--:--';
          const svgIcon = prayerIcons[prayer.key] || '🌙';

          return `
              <div style="
                background: #1e3a8a;
                border-radius: 16px;
                flex: 1;
                min-width: 0;
                padding: 1.2rem 0.4rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                overflow: hidden;
                box-shadow: 0 8px 32px rgba(30, 58, 138, 0.3), 0 4px 16px rgba(0, 0, 0, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.1);
              ">
                <div style="
                  width: 28px;
                  height: 28px;
                  margin-bottom: 0.6rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  z-index: 1;
                  filter: brightness(0) invert(1);
                ">${svgIcon}</div>
                <div style="
                  font-size: 0.6rem;
                  font-weight: 600;
                  color: white;
                  margin-bottom: 0.2rem;
                  text-align: center;
                  position: relative;
                  z-index: 1;
                  height: 2.4rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  line-height: 1.2;
                ">${prayer.ta}</div>
                <div style="
                  font-size: 0.6rem;
                  font-weight: bold;
                  color: white;
                  margin-bottom: 0.8rem;
                  text-align: center;
                  position: relative;
                  z-index: 1;
                  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
                ">${prayer.en}</div>
                <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  position: relative;
                  z-index: 1;
                ">
                  <div style="
                    font-size: 2.0rem;
                    font-weight: bold;
                    color: #fbbf24;
                    line-height: 1;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                  ">${time.split(':')[0]}</div>
                  <div style="
                    font-size: 2.0rem;
                    font-weight: medium;
                    color: white;
                    line-height: 1;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                  ">${time.split(':')[1]}</div>
                </div>
              </div>
            `;
        }).join('')}
        </div>
        <div style="
          text-align: center;
          margin: 0 1rem 1rem 1rem;
          font-size: 12px;
          color: #666;
          padding: 10px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
        ">
          Generated by www.salahtimes.vip
        </div>
      `;

      document.body.appendChild(tempContainer);

      // Use html2canvas to capture the image
      const html2canvas = await import('html2canvas');
      const canvas = await html2canvas.default(tempContainer, {
        width: 400,
        height: tempContainer.scrollHeight,
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        allowTaint: true
      });

      // Convert canvas to blob
      canvas.toBlob(async (blob) => {
        // Clean up
        document.body.removeChild(tempContainer);

        if (blob) {
          // Create shareable file
          const file = new File([blob], 'prayer-times.png', { type: 'image/png' });

          // Check if Web Share API is available
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            try {
              await navigator.share({
                title: 'Prayer Times',
                text: `Prayer times for ${zoneAreas} - ${dateDisplay}`,
                files: [file]
              });
            } catch (error) {
              console.log('Share cancelled or failed:', error);
              // Fallback to download
              downloadImage(blob);
            }
          } else {
            // Fallback to download
            downloadImage(blob);
          }
        }
      }, 'image/png');

    } catch (error) {
      console.error('Error generating image:', error);
      alert('Failed to generate image. Please try again.');
    }
  };

  const downloadImage = (blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'prayer-times.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleShare = async (type) => {
    setShowMenu(false);

    switch (type) {
      case 'image':
        await generatePrayerTimesImage();
        break;
      case 'text':
        const message = constructPrayerTimesMessage();
        if (navigator.share) {
          try {
            await navigator.share({
              title: 'Prayer Times',
              text: message,
              url: 'https://www.salahtimes.vip'
            });
          } catch (error) {
            console.log('Share cancelled');
          }
        } else {
          // Fallback: copy to clipboard
          try {
            await navigator.clipboard.writeText(message);
            alert('Prayer times copied to clipboard!');
          } catch (error) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = message;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            alert('Prayer times copied to clipboard!');
          }
        }
        break;
      case 'link':
        if (navigator.share) {
          try {
            await navigator.share({
              title: 'SL Prayer Times',
              text: 'Check out the prayer times app!',
              url: 'https://www.salahtimes.vip'
            });
          } catch (error) {
            console.log('Share cancelled');
          }
        } else {
          // Fallback: copy to clipboard
          navigator.clipboard.writeText('https://www.salahtimes.vip');
          alert('Link copied to clipboard!');
        }
        break;
      case 'calendar':
        // Add to calendar functionality
        alert('Calendar feature coming soon!');
        break;
      default:
        console.log(`Sharing via ${type}`);
    }
  };

  return (
    <>
      <button
        className="floating-share-btn"
        onClick={() => setShowMenu(!showMenu)}
        aria-label="Share"
      >
        {/* svg share icon */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.47 1.25.77 2.04.77 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.34 6.79 9.04 6 9.04c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.3 2.04-.76l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
        </svg>

      </button>

      {showMenu && (
        <div className="floating-share-menu">
          <button
            onClick={() => handleShare('calendar')}
            disabled
            className="disabled-button"
            title="Coming soon"
          >
            <span>📅</span>
            Add to Calendar
          </button>
          <button onClick={() => handleShare('text')}>
            <span>📝</span>
            Share Text
          </button>
          <button onClick={() => handleShare('link')}>
            <span>🔗</span>
            Share Link
          </button>
          <button onClick={() => handleShare('image')}>
            <span>📸</span>
            Share Image
          </button>
          <button onClick={() => {
            setShowInfo(true);
            setShowMenu(false);
          }}>
            <span>ℹ️</span>
            About
          </button>
        </div>
      )}

      {/* Close menu when clicking outside */}
      {showMenu && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setShowMenu(false)}
        />
      )}

      {showInfo && (
        <div className="info-popup-overlay" onClick={() => setShowInfo(false)}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <div className="info-header">
              <h3>About Salah Times</h3>
              <button
                className="info-close"
                onClick={() => setShowInfo(false)}
                aria-label="Close information"
              >
                ×
              </button>
            </div>
            <div className="info-content">
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  This prayer times and Hijri calendar are updated based on the official publications
                  by the All Ceylon Jamiathul Ulama (ACJU), the recognized Islamic religious body in Sri Lanka.
                  <strong>This is not an official ACJU application</strong>, but made solely for the easy use of the general public in public interest.
                </p>
                <p>
                  <strong>Convenience Feature:</strong> Select your zone once and it will be automatically saved for your ease. Your preferences including zone selection, theme (dark/light mode), and time format (12h/24h) are remembered across sessions.
                </p>
              </div>
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  இந்த தொழுகை நேரங்கள் மற்றும் ஹிஜ்ரி நாட்காட்டி இலங்கையின் அங்கீகரிக்கப்பட்ட
                  இஸ்லாமிய மத அமைப்பான அகில இலங்கை ஜமியத்துல் உலமா (ACJU) வெளியிடும்
                  அதிகாரப்பூர்வ வெளியீடுகளின் அடிப்படையில் புதுப்பிக்கப்படுகின்றன.
                  <strong>இது ACJU-வின் அதிகாரப்பூர்வ பயன்பாடு அல்ல</strong>, ஆனால் பொதுமக்களின் எளிய பயன்பாட்டிற்காக பொதுநலனில் மட்டுமே உருவாக்கப்பட்டுள்ளது.
                </p>
                <p>
                  <strong>வசதி அம்சம்:</strong> உங்கள் மண்டலத்தை ஒரு முறை தேர்ந்தெடுக்கவும், அது உங்கள் வசதிக்காக தானாக சேமிக்கப்படும். உங்கள் மண்டல தேர்வு, தீம் (இருள்/வெளிச்ச பயன்முறை) மற்றும் நேர வடிவம் (12h/24h) போன்ற விருப்பங்கள் அனைத்தும் அமர்வுகளில் நினைவில் வைக்கப்படும்.
                </p>
              </div>
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  මෙම යාච්ඤා කාල සහ හිජ්‍රි දින දර්ශනය ශ්‍රී ලංකාවේ පිළිගත් ඉස්ලාමීය ආගමික සංවිධානය වන
                  අකිල ඉලංකෙ ජමියතුල් උලමා (ACJU) විසින් ප්‍රකාශයට පත් කරන අධිකාරී ප්‍රකාශන මත පදනම්ව
                  යාවත්කාලීන කරනු ලැබේ.
                  <strong>මෙය ACJU හි අධිකාරී යෙදුමක් නොවේ</strong>, නමුත් පොදු ජනතාවගේ පහසු භාවිතය සඳහා පොදු උනන්දුව තුළ පමණක් සාදන ලද්දකි.
                </p>
                <p>
                  <strong>පහසුකම් අංගය:</strong> ඔබේ කලාපය එක් වරක් තෝරන්න, එය ඔබේ පහසුව සඳහා ස්වයංක්‍රීයව සුරක්ෂිත වේ. ඔබේ කලාප තේරීම, තේමාව (අඳුරු/ආලෝක ප්‍රකාරය) සහ කාල ආකෘතිය (12h/24h) ඇතුළු ඔබේ මනාපයන් සියල්ලම සැසිවාරවලදී මතක තබා ගනු ලැබේ.
                </p>
              </div>
              <div className="info-section">
                <h4>Disclaimer</h4>
                <p>
                  While we strive to provide accurate prayer times based on ACJU publications, users are advised to verify times with their local mosque or Islamic center for the most accurate local timings.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function QiblaBottomSheet({ onClose }) {
  const [userLocation, setUserLocation] = useState(null);
  const [qiblaData, setQiblaData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [useApiCompass, setUseApiCompass] = useState(false);
  const [isCompassLoading, setIsCompassLoading] = useState(false);
  const [deviceHeading, setDeviceHeading] = useState(0);
  const [isDeviceOrientationSupported, setIsDeviceOrientationSupported] = useState(false);
  const [compassRotation, setCompassRotation] = useState(0);

  // Qibla direction calculation
  const calculateQiblaDirection = (lat, lon) => {
    const kaabaLat = 21.4225;
    const kaabaLon = 39.8262;

    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const lat1 = toRadians(lat);
    const lon1 = toRadians(lon);
    const lat2 = toRadians(kaabaLat);
    const lon2 = toRadians(kaabaLon);

    const dLon = lon2 - lon1;
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    let bearing = Math.atan2(y, x);
    bearing = bearing * (180 / Math.PI);
    bearing = (bearing + 360) % 360;

    return bearing;
  };

  // Distance to Kaaba calculation
  const calculateDistanceToKaaba = (lat, lon) => {
    const kaabaLat = 21.4225;
    const kaabaLon = 39.8262;

    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const R = 6371; // Earth's radius in kilometers
    const dLat = toRadians(kaabaLat - lat);
    const dLon = toRadians(kaabaLon - lon);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat)) * Math.cos(toRadians(kaabaLat)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance;
  };

  // Get city name from coordinates
  const getCityName = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`
      );
      const data = await response.json();
      return data.address?.city || data.address?.town || data.address?.village || 'Unknown Location';
    } catch (error) {
      console.error('Error fetching city name:', error);
      return 'Unknown Location';
    }
  };

  const getCurrentLocation = async () => {
    setIsLoading(true);
    setError(null);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ lat: latitude, lon: longitude });

          // Calculate Qibla direction and distance
          const qiblaDirection = calculateQiblaDirection(latitude, longitude);
          const distance = calculateDistanceToKaaba(latitude, longitude);

          // Get city name
          const cityName = await getCityName(latitude, longitude);

          setQiblaData({
            direction: qiblaDirection,
            distance: distance,
            city: cityName,
            coordinates: { lat: latitude, lon: longitude }
          });

          setIsLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          let errorMessage = 'Unable to get your location. ';

          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage += 'Please allow location access and try again.';
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage += 'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              errorMessage += 'Location request timed out. Please try again.';
              break;
            default:
              errorMessage += 'Please check location permissions.';
              break;
          }

          setError(errorMessage);
          setIsLoading(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0 // Don't use cached location
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
      setIsLoading(false);
    }
  };

  // Generate API compass URL
  const getApiCompassUrl = (lat, lon) => {
    return `https://api.aladhan.com/v1/qibla/${lat}/${lon}/compass`;
  };

  // Auto-get location when component mounts
  useEffect(() => {
    getCurrentLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set compass loading when qiblaData is available and using API compass
  useEffect(() => {
    if (qiblaData && useApiCompass) {
      setIsCompassLoading(true);
    }
  }, [qiblaData, useApiCompass]);

  // Device orientation handling
  useEffect(() => {
    const handleOrientation = (event) => {
      console.log('Device orientation event:', event.alpha, event.beta, event.gamma);

      if (event.alpha !== null) {
        // Convert from device orientation to compass heading
        let heading = event.alpha;

        // iOS Safari uses different coordinate system
        if (typeof event.webkitCompassHeading !== 'undefined') {
          heading = event.webkitCompassHeading;
        }

        // Platform-specific adjustments for Android devicesn        const isAndroid = /Android/.test(navigator.userAgent);n        if (isAndroid) {n          // Android devices often need different handlingn          // Some Android devices have inverted or offset alpha valuesn          if (heading < 0) {n            heading = 360 + heading;n          }n          // Additional Android-specific adjustmentsn          // Some Android devices report compass heading differentlyn          heading = (360 - heading) % 360;n        }nn        console.log('Platform:', isAndroid ? 'Android' : 'iOS/Other');n        console.log('Raw alpha:', event.alpha);n        console.log('Processed heading:', heading);
        setDeviceHeading(heading);
        setIsDeviceOrientationSupported(true);

        // Rotate the entire compass face to counter the device rotation
        // Platform-specific compass rotation for Android fixn        const isAndroid = /Android/.test(navigator.userAgent);n        setCompassRotation(isAndroid ? heading : -heading);
      }
    };

    // Check if device orientation is supported
    if (typeof DeviceOrientationEvent !== 'undefined') {
      console.log('Device orientation is supported');
      setIsDeviceOrientationSupported(true);

      // Request permission for iOS 13+
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        console.log('Requesting device orientation permission...');
        DeviceOrientationEvent.requestPermission()
          .then(response => {
            console.log('Permission response:', response);
            if (response === 'granted') {
              window.addEventListener('deviceorientation', handleOrientation, true);
              console.log('Device orientation listener added');
            } else {
              console.log('Permission denied');
            }
          })
          .catch(error => {
            console.error('Permission error:', error);
          });
      } else {
        // For other browsers
        console.log('Adding device orientation listener (no permission needed)');
        window.addEventListener('deviceorientation', handleOrientation, true);
      }
    } else {
      console.log('Device orientation not supported');
    }

    return () => {
      window.removeEventListener('deviceorientation', handleOrientation, true);
    };
  }, []);

  return (
    <div className="qibla-bottom-sheet-overlay" onClick={onClose}>
      <div className="qibla-bottom-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="qibla-header">
          <h2>Universal Qibla Finder</h2>
          <button className="qibla-close" onClick={onClose} aria-label="Close Qibla finder">
            ×
          </button>
        </div>

        <div className="qibla-content">
          {isLoading && (
            <div className="qibla-loading">
              <div className="loading-spinner"></div>
              <p>Getting your location...</p>
            </div>
          )}

          {error && (
            <div className="qibla-error">
              <p>{error}</p>
              <button onClick={getCurrentLocation} className="retry-btn">
                Try Again
              </button>
            </div>
          )}

          {qiblaData && (
            <>
              <div className="qibla-info">
                <h3>{qiblaData.city}</h3>
                <p>The Qibla direction from {qiblaData.city} is <strong>{Math.round(qiblaData.direction)}°</strong>.</p>
                <p>Kaaba is {Math.round(qiblaData.distance)} km in this direction.</p>
                {/* {!useApiCompass && isDeviceOrientationSupported && (
                  <p className="compass-status">📱 Compass active - Rotate your device to align with North</p>
                )} */}
              </div>

              <div className="compass-container">
                {useApiCompass ? (
                  <div className="api-compass">
                    {isCompassLoading && (
                      <div className="compass-loading">
                        <div className="loading-spinner"></div>
                        <p>Calculating Qibla direction...</p>
                      </div>
                    )}
                    <img
                      src={getApiCompassUrl(qiblaData.coordinates.lat, qiblaData.coordinates.lon)}
                      alt="Qibla Compass"
                      className="api-compass-image"
                      style={{ display: isCompassLoading ? 'none' : 'block' }}
                      onLoad={() => setIsCompassLoading(false)}
                      onError={() => {
                        console.log('API compass failed to load, falling back to custom compass');
                        setUseApiCompass(false);
                        setIsCompassLoading(false);
                      }}
                    />
                  </div>
                ) : (
                  <div className="compass-wrapper">
                    <div className="svg-compass">
                      <svg width="280" height="280" viewBox="0 0 280 280">
                        {/* Compass Face - Rotates with device orientation */}
                        <g transform={`rotate(${compassRotation} 140 140)`}>
                          {/* Compass Circle */}
                          <circle cx="140" cy="140" r="135" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="3" />

                          {/* Cardinal Directions */}
                          <text x="140" y="25" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#374151">N</text>
                          <text x="255" y="145" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#374151">E</text>
                          <text x="140" y="265" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#374151">S</text>
                          <text x="25" y="145" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#374151">W</text>

                          {/* North Needle (Red) - Always points up */}
                          <polygon
                            points="140,30 135,140 145,140"
                            fill="#ef4444"
                            stroke="#dc2626"
                            strokeWidth="1"
                          />
                        </g>

                        {/* Qibla Needle (Green) - Rotates to Qibla direction AND with device rotation */}
                        <g transform={`rotate(${qiblaData.direction + compassRotation} 140 140)`}>
                          <polygon
                            points="140,30 135,140 145,140"
                            fill="#10b981"
                            stroke="#059669"
                            strokeWidth="1"
                          />
                        </g>

                        {/* Kaaba Icon - Moves with Qibla direction but stays upright */}
                        <g transform={`rotate(${qiblaData.direction + compassRotation} 140 140)`}>
                          <g transform={`translate(140, 30) rotate(${-(qiblaData.direction + compassRotation)})`}>

                            <image
                              href="/Kaaba.svg"
                              x="-12"
                              y="-12"
                              width="24"
                              height="24"
                              className="kaaba-icon"
                            />
                          </g>
                        </g>

                        {/* Center Dot */}
                        <circle cx="140" cy="140" r="8" fill="#374151" />
                      </svg>
                    </div>
                    {/* <div className="qibla-direction-info">
                      <p>Qibla Direction: <strong>{Math.round(qiblaData.direction)}°</strong></p>
                      {isDeviceOrientationSupported ? (
                        <p className="compass-status">
                          📱 Compass active - Rotate device to align
                        </p>
                      ) : (
                        <div className="compass-permission">
                          <p>Device orientation not available</p>
                          <button
                            className="enable-compass-btn"
                            onClick={() => {
                              if (typeof DeviceOrientationEvent !== 'undefined' &&
                                typeof DeviceOrientationEvent.requestPermission === 'function') {
                                DeviceOrientationEvent.requestPermission()
                                  .then(response => {
                                    if (response === 'granted') {
                                      window.location.reload();
                                    }
                                  });
                              }
                            }}
                          >
                            Enable Compass
                          </button>
                        </div>
                      )}
                    </div> */}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function FloatingQiblaButton() {
  const [showQibla, setShowQibla] = useState(false);

  return (
    <>
      <button
        className="floating-qibla-btn"
        onClick={() => setShowQibla(true)}
        aria-label="Qibla direction finder"
      >
        <img
          src="/Kaaba.svg"
          alt="Kaaba"
          width="24"
          height="24"
          className="kaaba-icon-btn"
        />
        <span>Qibla</span>
      </button>

      {showQibla && (
        <QiblaBottomSheet onClose={() => setShowQibla(false)} />
      )}
    </>
  );
}

function FloatingInfoButton() {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
      <button
        className="floating-info-btn"
        onClick={() => setShowInfo(!showInfo)}
        aria-label="Information about prayer times"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
      </button>

      {showInfo && (
        <div className="info-popup-overlay" onClick={() => setShowInfo(false)}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <div className="info-header">
              <h3>About Salah Times</h3>
              <button
                className="info-close"
                onClick={() => setShowInfo(false)}
                aria-label="Close information"
              >
                ×
              </button>
            </div>
            <div className="info-content">
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  This prayer times and Hijri calendar are updated based on the official publications
                  by the All Ceylon Jamiathul Ulama (ACJU), the recognized Islamic religious body in Sri Lanka.
                  <strong>This is not an official ACJU application</strong>, but made solely for the easy use of the general public in public interest.
                </p>
                <p>
                  <strong>Convenience Feature:</strong> Select your zone once and it will be automatically saved for your ease. Your preferences including zone selection, theme (dark/light mode), and time format (12h/24h) are remembered across sessions.
                </p>
              </div>
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  இந்த தொழுகை நேரங்கள் மற்றும் ஹிஜ்ரி நாட்காட்டி இலங்கையின் அங்கீகரிக்கப்பட்ட
                  இஸ்லாமிய மத அமைப்பான அகில இலங்கை ஜமியத்துல் உலமா (ACJU) வெளியிடும்
                  அதிகாரப்பூர்வ வெளியீடுகளின் அடிப்படையில் புதுப்பிக்கப்படுகின்றன.
                  <strong>இது ACJU-வின் அதிகாரப்பூர்வ பயன்பாடு அல்ல</strong>, ஆனால் பொதுமக்களின் எளிய பயன்பாட்டிற்காக பொதுநலனில் மட்டுமே உருவாக்கப்பட்டுள்ளது.
                </p>
                <p>
                  <strong>வசதி அம்சம்:</strong> உங்கள் மண்டலத்தை ஒரு முறை தேர்ந்தெடுக்கவும், அது உங்கள் வசதிக்காக தானாக சேமிக்கப்படும். உங்கள் மண்டல தேர்வு, தீம் (இருள்/வெளிச்ச பயன்முறை) மற்றும் நேர வடிவம் (12h/24h) போன்ற விருப்பங்கள் அனைத்தும் அமர்வுகளில் நினைவில் வைக்கப்படும்.
                </p>
              </div>
              <div className="info-section">
                <h4>Info</h4>
                <p>
                  If you have inquiries contact the developer via email.<br />
                  உங்களுக்கு கேள்விகள் இருந்தால் மின்னஞ்சலில் தொடர்புகொள்ளுங்கள்.<br />Ziaul Hasan | zhasan.sl@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function UpNext({ selectedArea, selectedDate, prayerTimes, isLoading, timeFormat }) {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [nextPrayer, setNextPrayer] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState({ hours: 0, minutes: 0, seconds: 0 });

  // Update current time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Determine next prayer based on current time
  useEffect(() => {
    if (!prayerTimes || Object.keys(prayerTimes).length === 0) {
      setNextPrayer(null);
      return;
    }

    const prayerOrder = ['fajr', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'];
    const currentHour = currentTime.getHours();
    const currentMinute = currentTime.getMinutes();
    const currentTimeInMinutes = currentHour * 60 + currentMinute;

    let nextPrayerFound = null;

    // Find the next prayer
    for (const prayerKey of prayerOrder) {
      const prayerData = prayerTimes[prayerKey];
      if (prayerData && prayerData.h !== null && prayerData.m !== null) {
        const prayerTimeInMinutes = prayerData.h * 60 + prayerData.m;

        if (prayerTimeInMinutes > currentTimeInMinutes) {
          nextPrayerFound = {
            name: prayerKey.toUpperCase(),
            time: prayerData,
            key: prayerKey
          };
          break;
        }
      }
    }

    // If no next prayer found today, find first prayer of next day
    if (!nextPrayerFound) {
      for (const prayerKey of prayerOrder) {
        const prayerData = prayerTimes[prayerKey];
        if (prayerData && prayerData.h !== null && prayerData.m !== null) {
          nextPrayerFound = {
            name: prayerKey.toUpperCase(),
            time: prayerData,
            key: prayerKey
          };
          break;
        }
      }
    }

    setNextPrayer(nextPrayerFound);
  }, [prayerTimes, currentTime]);

  // Calculate time remaining
  useEffect(() => {
    if (!nextPrayer) {
      setTimeRemaining({ hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const now = new Date();
    const prayerTime = new Date();
    prayerTime.setHours(nextPrayer.time.h, nextPrayer.time.m, 0, 0);

    // If prayer time is today and has passed, assume it's for tomorrow
    if (prayerTime <= now) {
      prayerTime.setDate(prayerTime.getDate() + 1);
    }

    const timeDiff = prayerTime - now;
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    setTimeRemaining({ hours, minutes, seconds });
  }, [nextPrayer, currentTime]);



  const formatTime = (time) => {
    return `${time.hours.toString().padStart(2, '0')}:${time.minutes.toString().padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`;
  };

  const formatPrayerTime = (time) => {
    if (timeFormat === "12h") {
      // Convert to 12-hour format
      let hour = time.h;
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      hour = hour === 0 ? 12 : hour;
      return `${hour.toString().padStart(2, '0')}:${time.m.toString().padStart(2, '0')} ${ampm}`;
    } else {
      // 24-hour format
      return `${time.h.toString().padStart(2, '0')}:${time.m.toString().padStart(2, '0')}`;
    }
  };

  const getPrayerIcon = (prayerKey) => {
    const iconMap = {
      'fajr': 'subah.svg',
      'sunrise': 'sunrise.svg',
      'luhar': 'luhar.svg',
      'asr': 'asr.svg',
      'maghrib': 'maghrib.svg',
      'isha': 'isha.svg'
    };
    return iconMap[prayerKey] || 'subah.svg';
  };

  const getPrayerDisplayName = (prayerKey) => {
    const nameMap = {
      'fajr': 'SUBAH',
      'sunrise': 'SUNRISE',
      'luhar': 'LUHAR',
      'asr': 'ASR',
      'maghrib': 'MAGHRIB',
      'isha': 'ISHA'
    };
    return nameMap[prayerKey] || prayerKey.toUpperCase();
  };

  const getPrayerTamilName = (prayerKey) => {
    const tamilNameMap = {
      'fajr': 'சுபஹ்',
      'sunrise': 'சூரிய உதயம்',
      'luhar': 'லுஹர்',
      'asr': 'அஸர்',
      'maghrib': 'மஃரிப்',
      'isha': 'இஷா'
    };
    return tamilNameMap[prayerKey] || prayerKey;
  };

  if (isLoading) {
    return (
      <div className="up-next-container">
        <div className="up-next-card up-next-loading">
          <div className="up-next-loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!nextPrayer) {
    return (
      <div className="up-next-container">
        <div className="up-next-card">
          <div className="up-next-label">UP NEXT</div>
          <div className="up-next-tamil-label">அடுத்து</div>
          <div className="up-next-prayer">No prayer times available</div>
          <div className="up-next-timer">--:--:--</div>
        </div>
      </div>
    );
  }

  // Helper function to get time-based background and sun/moon position
  const getTimeBasedStyling = () => {
    const hour = new Date().getHours();

    // Fajr (Dawn) - 4-6 AM
    if (hour >= 4 && hour < 6) {
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        celestialPosition: 'left',
        celestialType: 'dawn',
        overlay: 'rgba(255, 255, 255, 0.1)'
      };
    }
    // Sunrise - 6-8 AM
    else if (hour >= 6 && hour < 8) {
      return {
        background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff9a9e 100%)',
        celestialPosition: 'center-left',
        celestialType: 'sunrise',
        overlay: 'rgba(255, 255, 255, 0.15)'
      };
    }
    // Dhuhr (Midday) - 8 AM - 2 PM
    else if (hour >= 8 && hour < 14) {
      return {
        background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff9a9e 100%)',
        celestialPosition: 'center',
        celestialType: 'sun',
        overlay: 'rgba(255, 255, 255, 0.1)'
      };
    }
    // Asr (Afternoon) - 2-5 PM
    else if (hour >= 14 && hour < 17) {
      return {
        background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff9a9e 100%)',
        celestialPosition: 'center-right',
        celestialType: 'afternoon',
        overlay: 'rgba(255, 255, 255, 0.1)'
      };
    }
    // Maghrib (Sunset) - 5-7 PM
    else if (hour >= 17 && hour < 19) {
      return {
        background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff9a9e 100%)',
        celestialPosition: 'right',
        celestialType: 'sunset',
        overlay: 'rgba(255, 255, 255, 0.1)'
      };
    }
    // Isha (Night) - 7 PM - 4 AM
    else {
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        celestialPosition: 'right',
        celestialType: 'night',
        overlay: 'rgba(255, 255, 255, 0.05)'
      };
    }
  };

  const timeStyling = getTimeBasedStyling();

  return (
    <div className="up-next-container">
      <div className="up-next-card" style={{ background: timeStyling.background }}>
        <div className="up-next-cutout"></div>

        <div className="up-next-overlay" style={{
          background: timeStyling.overlay
        }}></div>

        <div className="up-next-content">
          <div className="up-next-left">
            <div className="up-next-label">UP NEXT</div>
            <div className="up-next-tamil-label">அடுத்து</div>
          </div>

          <div className="up-next-center">
            <div className="up-next-prayer-icon">
              <img
                src={`/${getPrayerIcon(nextPrayer.key)}`}
                alt={getPrayerDisplayName(nextPrayer.key)}
                style={{
                  filter: 'brightness(0) saturate(100%) invert(1)',
                  width: '2.5rem',
                  height: '2.5rem'
                }}
              />
            </div>
          </div>

          <div className="up-next-right">
            <div className="up-next-prayer">
              {getPrayerDisplayName(nextPrayer.key)} | {getPrayerTamilName(nextPrayer.key)}
            </div>
            <div className="up-next-timer">{formatTime(timeRemaining)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ⚡ Bolt: Moved HADITHS array outside component to prevent reallocation on every render
const HADITHS = [
  {
    text: "Salah is the key to Jannah",
    tamil: "சொர்க்கத்தின் திறவுகோல் தொழுகை",
    reference: "Prophet Muhammad ﷺ",
    arabic: "الصَّلَاةُ مِفْتَاحُ الْجَنَّةِ"
  },
  {
    text: "The first thing that will be judged among a person's deeds on the Day of Resurrection is the prayer",
    tamil: "மறுமை நாளில் மனிதனின் செயல்களில் முதலில் விசாரிக்கப்படுவது தொழுகையே",
    reference: "Abu Hurairah (RA)",
    arabic: "إِنَّ أَوَّلَ مَا يُحَاسَبُ بِهِ الْعَبْدُ يَوْمَ الْقِيَامَةِ مِنْ عَمَلِهِ صَلَاتُهُ"
  },
  {
    text: "Between a person and disbelief is the abandonment of prayer",
    tamil: "மனிதனுக்கும் இணைவைப்புக்கும் இடையே தொழுகையை விட்டுவிடுவதே உள்ளது",
    reference: "Prophet Muhammad ﷺ",
    arabic: "بَيْنَ الرَّجُلِ وَبَيْنَ الشِّرْكِ وَالْكُفْرِ تَرْكُ الصَّلَاةِ"
  },
  {
    text: "The prayer is the pillar of Islam",
    tamil: "தொழுகை இஸ்லாத்தின் தூண்",
    reference: "Prophet Muhammad ﷺ",
    arabic: "الصَّلَاةُ عِمَادُ الدِّينِ"
  }
];

function HadithQuote() {
  const [currentHadith, setCurrentHadith] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHadith((prev) => (prev + 1) % HADITHS.length);
    }, 8000); // Change every 8 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hadith-quote">
      <div className="hadith-content">
        <div className="hadith-text">
          "{HADITHS[currentHadith].text}"
        </div>
        <div className="hadith-tamil">
          "{HADITHS[currentHadith].tamil}"
        </div>
        <div className="hadith-arabic">
          {HADITHS[currentHadith].arabic}
        </div>
        <div className="hadith-reference">
          — {HADITHS[currentHadith].reference}
        </div>
      </div>
      <div className="hadith-indicators">
        {HADITHS.map((_, index) => (
          <div
            key={index}
            className={`hadith-dot ${index === currentHadith ? 'active' : ''}`}
            onClick={() => setCurrentHadith(index)}
          />
        ))}
      </div>
    </div>
  );
}

// ⚡ Bolt: Moved HIJRI_MONTHS array outside component to prevent reallocation on every render
// Hijri months array
const HIJRI_MONTHS = [
  "Muharram", "Safar", "Rabee'unil Awwal", "Rabee'unith Thaani",
  "Jumaadal Oola", "Jumaadal Aakhirah", "Rajab", "Sha'baan",
  "Ramadaan", "Shawwaal", "Dhul Qa'dah", "Dhul Hijjah"
];

// ⚡ Bolt: Moved ARABIC_DAYS array outside component to prevent reallocation on every render
// Arabic day names
const ARABIC_DAYS = [
  "Yawmul Ahad", "Yawmul Ithnayn", "Yawmul Thulatha",
  "Yawmul Arba'a", "Yawmul Khamees", "Yawmul Jumu'ah", "Yawmul Sabt"
];

// ⚡ Bolt: Moved ENGLISH_DAYS array outside component to prevent reallocation on every render
// English day names
const ENGLISH_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function HijriCalendar({ selectedDate, selectedArea }) {
  const [calendarData, setCalendarData] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [showEventPopup, setShowEventPopup] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  console.log("Weekday mapping:", ENGLISH_DAYS.map((day, index) => `${index}: ${day}`));

  // Function to get ordinal suffix for numbers
  const getOrdinalSuffix = (num) => {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) {
      return num + "ST";
    }
    if (j === 2 && k !== 12) {
      return num + "ND";
    }
    if (j === 3 && k !== 13) {
      return num + "RD";
    }
    return num + "TH";
  };

  useEffect(() => {
    const fetchCalendarData = async () => {
      if (!selectedDate) return;

      console.log("Selected date:", selectedDate);
      console.log("Selected date string:", selectedDate.toDateString());

      setIsLoading(true);
      try {
        // Get current Hijri month and year from selected date
        const day = selectedDate.getDate().toString().padStart(2, '0');
        const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
        const year = selectedDate.getFullYear().toString().slice(-2);

        const dateKey = `${day}${month}${year}`;
        const dateKeyAlt = `${year}${month}${day}`;

        console.log("Looking for dateKey:", dateKey);

        let metaRef = ref(db, `meta/${dateKey}/LK`);
        let snapshot = await get(metaRef);
        let currentMeta = snapshot.val();

        if (!currentMeta) {
          console.log("Looking for alternate dateKey:", dateKeyAlt);
          metaRef = ref(db, `meta/${dateKeyAlt}/LK`);
          snapshot = await get(metaRef);
          currentMeta = snapshot.val();
        }

        console.log("Found currentMeta:", currentMeta);

        if (currentMeta && currentMeta.monthHijri && currentMeta.yearHijri) {
          setCurrentMonth({
            month: currentMeta.monthHijri,
            year: currentMeta.yearHijri
          });

          // Fetch all data for this Hijri month and year
          const allMetaRef = ref(db, "meta");
          const allSnapshot = await get(allMetaRef);
          const allMeta = allSnapshot.val() || {};

          const monthData = [];
          Object.entries(allMeta).forEach(([dateKey, countries]) => {
            Object.entries(countries).forEach(([country, data]) => {
              // Convert yearHijri to string for comparison since some are strings and some are numbers
              const dataYearHijri = data.yearHijri?.toString();
              const currentYearHijri = currentMeta.yearHijri?.toString();

              // Include all entries for the Hijri month, regardless of Gregorian month
              if (data.monthHijri === currentMeta.monthHijri &&
                dataYearHijri === currentYearHijri) {
                monthData.push({
                  dateKey,
                  country,
                  ...data
                });
              }
            });
          });

          console.log("Month data collected:", monthData.length, "entries");
          console.log("Month data sample:", monthData.slice(0, 3));

          // Debug: Let's see all entries with dayHijri === "1"
          const dayOneEntries = monthData.filter(d => d.dayHijri === "1" || d.dayHijri === 1);
          console.log("Day 1 entries found:", dayOneEntries);

          // Also search for day 1 specifically
          const firstDayEntry = Object.entries(allMeta).find(([dateKey, countries]) => {
            return Object.values(countries).some(data => {
              const dataYearHijri = data.yearHijri?.toString();
              const currentYearHijri = currentMeta.yearHijri?.toString();

              return (data.dayHijri === "1" || data.dayHijri === 1) &&
                data.monthHijri === currentMeta.monthHijri &&
                dataYearHijri === currentYearHijri;
            });
          });

          console.log("First day entry found:", firstDayEntry);
          if (firstDayEntry) {
            const [dateKey, countries] = firstDayEntry;
            const firstDayData = Object.values(countries).find(data => {
              const dataYearHijri = data.yearHijri?.toString();
              const currentYearHijri = currentMeta.yearHijri?.toString();

              return (data.dayHijri === "1" || data.dayHijri === 1) &&
                data.monthHijri === currentMeta.monthHijri &&
                dataYearHijri === currentYearHijri;
            });
            console.log("First day data from entry:", firstDayData);
          }

          // Debug: Let's see what we're actually searching for
          console.log("Searching for dayHijri: 1, monthHijri:", currentMeta.monthHijri, "yearHijri:", currentMeta.yearHijri);

          // Let's also check all entries to see what we have
          const allEntries = Object.entries(allMeta).map(([dateKey, countries]) => {
            const data = Object.values(countries)[0];
            return { dateKey, dayHijri: data.dayHijri, monthHijri: data.monthHijri, yearHijri: data.yearHijri };
          });
          console.log("All entries:", allEntries);

          console.log("Month data found:", monthData);

          // Find the actual first day of the Hijri month
          const firstDayData = monthData.find(d => d.dayHijri === "1" || d.dayHijri === 1);
          console.log("First day data from monthData:", firstDayData);

          if (firstDayData) {
            console.log("Found first day data in monthData, using real data");
            setCalendarData(monthData);
          } else if (firstDayEntry) {
            console.log("Found first day entry in allMeta, extracting data");
            const [dateKey, countries] = firstDayEntry;
            const firstDayData = Object.values(countries).find(data =>
              data.dayHijri === "1" &&
              data.monthHijri === currentMeta.monthHijri &&
              data.yearHijri === currentMeta.yearHijri
            );

            if (firstDayData) {
              // Add the first day data to the month data
              const completeMonthData = [{
                dateKey,
                country: 'LK',
                ...firstDayData
              }, ...monthData];
              console.log("Created complete month data with first day:", completeMonthData);
              setCalendarData(completeMonthData);
            } else {
              setCalendarData(monthData);
            }
          } else {
            console.log("No first day data found anywhere, using available data");
            setCalendarData(monthData);
          }
        } else {
          console.log("No meta data found, creating fallback calendar");
          // Fallback: Create a basic calendar for current month
          const today = new Date();
          const currentMonthName = today.toLocaleString('default', { month: 'long' });
          const currentYear = today.getFullYear();

          setCurrentMonth({
            month: "Muharram", // Default to Muharram
            year: 1447 // Default to 1447
          });

          // Create sample data for demonstration
          const sampleData = [];
          const daysInMonth = new Date(currentYear, today.getMonth() + 1, 0).getDate();

          for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(currentYear, today.getMonth(), day);
            const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            const arabicWeekdays = ["Yawmul Ahad", "Yawmul Ithnayn", "Yawmul Thulatha", "Yawmul Arba'a", "Yawmul Khamees", "Yawmul Jumu'ah", "Yawmul Sabt"];

            sampleData.push({
              dayHijri: day,
              dayGregorian: day,
              monthGregorian: currentMonthName,
              yearGregorian: currentYear,
              dayNameEn: weekdays[date.getDay()],
              dayNameArabic: arabicWeekdays[date.getDay()],
              monthHijri: "Muharram",
              yearHijri: 1447,
              event: day === 15 ? "Sample Event" : "",
              isTentative: false
            });
          }

          console.log("Using fallback sample data:", sampleData);
          setCalendarData(sampleData);
        }
      } catch (error) {
        console.error("Error fetching calendar data:", error);
        // Fallback on error
        const today = new Date();
        setCurrentMonth({
          month: "Muharram",
          year: 1447
        });
        setCalendarData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCalendarData();
  }, [selectedDate]);

  const generateCalendarGrid = () => {
    if (!currentMonth || calendarData.length === 0) {
      return [];
    }

    // Find the first day of the month
    const firstDayData = calendarData.find(d => d.dayHijri === "1" || d.dayHijri === 1);

    console.log("First day data for grid:", firstDayData);
    console.log("First day dayNameEn:", firstDayData?.dayNameEn);
    console.log("First day dateKey:", firstDayData?.dateKey);
    console.log("Calendar data length:", calendarData.length);
    console.log("Calendar data sample:", calendarData.slice(0, 5));

    if (!firstDayData) {
      console.log("No first day data found, using fallback");
      // Fallback: assume first day starts on Sunday (0)
      const firstDayOfWeek = 0;
      const maxDays = Math.max(...calendarData.map(d => parseInt(d.dayHijri)), 30);

      const grid = [];
      let currentDay = 1;

      for (let week = 0; week < 6; week++) {
        const weekDays = [];
        for (let day = 0; day < 7; day++) {
          if (week === 0 && day < firstDayOfWeek) {
            weekDays.push(null); // Empty cell
          } else if (currentDay <= maxDays) {
            const dayData = calendarData.find(d => parseInt(d.dayHijri) === currentDay);
            weekDays.push(dayData || { dayHijri: currentDay });
            currentDay++;
          } else {
            weekDays.push(null); // Empty cell
          }
        }
        grid.push(weekDays);
      }

      return grid;
    }

    // Get the day of week for the first day using dayNameEn from meta data
    const dayNameToIndex = {
      'Sunday': 0,
      'Monday': 1,
      'Tuesday': 2,
      'Wednesday': 3,
      'Thursday': 4,
      'Friday': 5,
      'Saturday': 6
    };

    const firstDayOfWeek = dayNameToIndex[firstDayData.dayNameEn] || 0;

    console.log("First day dayNameEn:", firstDayData.dayNameEn);
    console.log("First day of week calculated:", firstDayOfWeek);

    // Create calendar grid
    const grid = [];
    let currentDay = 1;
    const maxDays = Math.max(...calendarData.map(d => parseInt(d.dayHijri)));

    for (let week = 0; week < 6; week++) {
      const weekDays = [];
      let hasDataInWeek = false;

      for (let day = 0; day < 7; day++) {
        if (week === 0 && day < firstDayOfWeek) {
          weekDays.push(null); // Empty cell
        } else if (currentDay <= maxDays) {
          const dayData = calendarData.find(d => parseInt(d.dayHijri) === currentDay);
          if (dayData) {
            weekDays.push(dayData);
          } else {
            // Create fallback data with Gregorian info
            const fallbackDate = new Date();
            fallbackDate.setDate(currentDay);
            weekDays.push({
              dayHijri: currentDay,
              dayGregorian: currentDay,
              monthGregorian: fallbackDate.toLocaleString('default', { month: 'long' }),
              yearGregorian: fallbackDate.getFullYear()
            });
          }
          currentDay++;
          hasDataInWeek = true;
        } else {
          weekDays.push(null); // Empty cell
        }
      }

      // Only add week if it has data
      if (hasDataInWeek) {
        grid.push(weekDays);
      }
    }

    console.log("Final grid:", grid);
    return grid;
  };

  const handleDayClick = (dayData) => {
    if (dayData && dayData.event) {
      setSelectedEvent(dayData);
      setShowEventPopup(true);
    }
  };

  // Function to check if a day is the current day
  const isCurrentDay = (dayData) => {
    if (!dayData || !dayData.dateKey) return false;

    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString().slice(-2);

    const todayKey = `${day}${month}${year}`;
    const todayKeyAlt = `${year}${month}${day}`;

    return dayData.dateKey === todayKey || dayData.dateKey === todayKeyAlt;
  };

  const formatGregorianDate = (dayData) => {
    if (!dayData || !dayData.monthGregorian || !dayData.dayGregorian) return "";
    return `${dayData.monthGregorian.toUpperCase().substring(0, 3)} ${dayData.dayGregorian}`;
  };

  if (isLoading) {
    return (
      <div className="hijri-calendar">
        <div className="calendar-loading">
          <div className="spinner"></div>
          <p>Loading Hijri Calendar...</p>
        </div>
      </div>
    );
  }

  if (!currentMonth) {
    return null; // Don't show calendar if no data
  }

  const calendarGrid = generateCalendarGrid();

  return (
    <>
      <div id="hijri-calendar" className="hijri-calendar">
        <div className="calendar-header">
          <div className="calendar-title">
            <h3>{currentMonth.month}</h3>
            <p className="gregorian-period">
              {(() => {
                const firstDay = calendarData.find(d => d.dayHijri === "1" || d.dayHijri === 1);
                const lastDay = calendarData[calendarData.length - 1];
                if (firstDay && lastDay) {
                  const firstMonth = firstDay.monthGregorian.toUpperCase();
                  const lastMonth = lastDay.monthGregorian.toUpperCase();
                  if (firstMonth === lastMonth) {
                    return `${firstMonth} ${firstDay.yearGregorian}`;
                  } else {
                    return `${firstMonth} - ${lastMonth} ${firstDay.yearGregorian}`;
                  }
                }
                return "";
              })()}
            </p>
          </div>
          <div className="calendar-hijri-info">
            <div className="hijri-badge">
              {getOrdinalSuffix(HIJRI_MONTHS.indexOf(currentMonth.month) + 1)} MONTH
            </div>
            <p className="hijri-year">HIJRI {currentMonth.year}</p>
          </div>
        </div>

        <div className="calendar-grid">
          <div className="calendar-weekdays">
        {ENGLISH_DAYS.map((day, index) => (
              <div key={day} className="weekday-header">
                <div className="english-day">{day.slice(0, 3).toUpperCase()}</div>
            <div className="arabic-day">{ARABIC_DAYS[index]}</div>
              </div>
            ))}
          </div>

          <div className="calendar-days">
            {calendarGrid.map((week, weekIndex) => (
              <div key={weekIndex} className="calendar-week">
                {week.map((dayData, dayIndex) => {
                  // Debug: Check if day 30 has tentative flag
                  if (dayData && dayData.dayHijri === 30) {
                    console.log('Day 30 data:', dayData);
                    console.log('Day 30 isTentative:', dayData.isTentative);
                  }

                  return (
                    <div
                      key={dayIndex}
                      className={`calendar-day ${!dayData ? 'empty' : ''} ${dayData?.event ? 'has-event' : ''} ${dayData?.isTentative ? 'tentative' : ''} ${isCurrentDay(dayData) ? 'current-day' : ''}`}
                      onClick={() => handleDayClick(dayData)}
                    >
                      {dayData && (
                        <>
                          <div className="hijri-day">{dayData.dayHijri}</div>
                          <div className="gregorian-date">{formatGregorianDate(dayData)}</div>
                          {dayData.event && <div className="event-indicator">●</div>}
                          {dayData.isTentative && <div className="tentative-indicator">?</div>}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>

      {showEventPopup && selectedEvent && (
        <div className="event-popup-overlay" onClick={() => setShowEventPopup(false)}>
          <div className="event-popup" onClick={(e) => e.stopPropagation()}>
            <div className="event-popup-header">
              <h3>{selectedEvent.dayGregorian} {selectedEvent.monthGregorian}, {selectedEvent.yearGregorian}</h3>
              <button
                className="event-popup-close"
                onClick={() => setShowEventPopup(false)}
              >
                ×
              </button>
            </div>
            <div className="event-popup-content">
              <div className="hijri-date-display">
                {selectedEvent.dayHijri} {selectedEvent.monthHijri}, {selectedEvent.yearHijri}
              </div>
              <div className="event-content">
                {selectedEvent.event}
              </div>
              {selectedEvent.isTentative && (
                <div className="event-tentative">
                  <span className="tentative-badge">Tentative</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function FeedbackLink() {
  return (
    <div className="feedback-link">
      <a href="#">SUGGESTIONS / FEEDBACK</a>
    </div>
  );
}

function LockButton({ onClick }) {
  return (
    <button className="lock-btn" onClick={onClick} title="Admin Login">
      <span role="img" aria-label="lock">🔒</span>
    </button>
  );
}

function ContactModal({ onClose }) {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [sendStatus, setSendStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) {
      setSendStatus("Please fill in all fields");
      return;
    }

    setIsSending(true);
    setSendStatus("");

    try {
      // Create mailto link with pre-filled content
      const subject = "Contact from SL Prayer Times App";
      const body = `Name: ${name}\n\nMessage:\n${message}`;
      const mailtoLink = `mailto:zhasan.sl@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      // Open default email client
      window.open(mailtoLink);

      setSendStatus("Email client opened successfully!");
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      setSendStatus("Error opening email client. Please email zhasan.sl@gmail.com directly.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Contact the Developer</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Your Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>
          <div className="form-group">
            <label>Message:</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message here..."
              rows="5"
              required
            />
          </div>
          {sendStatus && (
            <div className={`form-message ${sendStatus.includes("Error") ? "form-error" : "form-success"}`}>
              {sendStatus}
            </div>
          )}
          <div className="form-actions">
            <button
              type="submit"
              className="primary"
              disabled={isSending}
            >
              {isSending ? "Opening Email..." : "Send Now"}
            </button>
            <button type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function LoginPopup({ onClose, onLogin, error }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  return (
    <div className="login-popup-overlay">
      <div className="login-popup">
        <h2>Admin Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <div className="login-error">{error}</div>}
        <div className="login-actions">
          <button onClick={() => onLogin(email, password)}>Login</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function ManagePrayerTimes() {
  const [prayerTimes, setPrayerTimes] = useState([]);
  const [zones, setZones] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("LK");
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    fajr: { h: "", m: "" },
    sunrise: { h: "", m: "" },
    luhar: { h: "", m: "" },
    asr: { h: "", m: "" },
    maghrib: { h: "", m: "" },
    isha: { h: "", m: "" }
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Filter states
  const [filterZone, setFilterZone] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");

  // Sorting states
  const [sortKey, setSortKey] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");

  // Swap zones states
  const [showSwapSidebar, setShowSwapSidebar] = useState(false);
  const [swapSourceZone, setSwapSourceZone] = useState("");
  const [swapTargetZone, setSwapTargetZone] = useState("");
  const [swapMonth, setSwapMonth] = useState("");
  const [swapYear, setSwapYear] = useState("");
  const [swapEntries, setSwapEntries] = useState([]);
  const [swapCurrentDayIndex, setSwapCurrentDayIndex] = useState(0);
  const [usePreviousYear, setUsePreviousYear] = useState(true);

  useEffect(() => {
    const settingsRef = ref(db, "settings/usePreviousYearForPrayerTimes");
    const unsubscribe = onValue(settingsRef, (snapshot) => {
      const value = snapshot.val();
      setUsePreviousYear(value !== false);
    });
    return () => unsubscribe();
  }, []);

  const handleToggleUsePreviousYear = async (enabled) => {
    try {
      await set(ref(db, "settings/usePreviousYearForPrayerTimes"), enabled);
      setUsePreviousYear(enabled);
    } catch (err) {
      setError("Failed to update setting: " + err.message);
    }
  };

  // Fetch zones for dropdown
  useEffect(() => {
    const zonesRef = ref(db, "zones");
    const unsubscribe = onValue(zonesRef, (snapshot) => {
      const data = snapshot.val() || {};
      const zonesList = [];
      Object.entries(data).forEach(([key, zoneData]) => {
        if (key !== "areas") {
          zonesList.push({
            key,
            title: zoneData.title || key
          });
        }
      });
      zonesList.sort((a, b) => a.title.localeCompare(b.title));
      setZones(zonesList);
    });
    return () => unsubscribe();
  }, []);

  // Fetch prayer times data
  useEffect(() => {
    const prayerTimesRef = ref(db, "prayerTimes");
    const unsubscribe = onValue(prayerTimesRef, (snapshot) => {
      const data = snapshot.val() || {};
      const timesList = [];

      Object.entries(data).forEach(([date, countries]) => {
        Object.entries(countries).forEach(([country, zones]) => {
          Object.entries(zones).forEach(([zone, prayers]) => {
            timesList.push({
              date,
              country,
              zone,
              prayers,
              id: `${date}_${country}_${zone}`
            });
          });
        });
      });

      // Sort by date (newest first)
      timesList.sort((a, b) => b.date.localeCompare(a.date));
      setPrayerTimes(timesList);
    });
    return () => unsubscribe();
  }, []);

  const handleAdd = async () => {
    if (!selectedDate || !selectedZone) {
      setError("Please select date and zone");
      return;
    }

    // Validate prayer times
    const prayers = ['fajr', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'];
    for (const prayer of prayers) {
      if (!formData[prayer].h || !formData[prayer].m) {
        setError(`Please enter ${prayer.toUpperCase()} time`);
        return;
      }
      const hour = parseInt(formData[prayer].h);
      const minute = parseInt(formData[prayer].m);
      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        setError(`Invalid time for ${prayer.toUpperCase()}`);
        return;
      }
    }

    try {
      const prayerTimesRef = ref(db, `prayerTimes/${selectedDate}/${selectedCountry}/${selectedZone}`);
      await set(prayerTimesRef, formData);

      setSuccess("Prayer times added successfully!");
      setFormData({
        fajr: { h: "", m: "" },
        sunrise: { h: "", m: "" },
        luhar: { h: "", m: "" },
        asr: { h: "", m: "" },
        maghrib: { h: "", m: "" },
        isha: { h: "", m: "" }
      });
      setSelectedDate("");
      setSelectedZone("");
      setError("");

      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to add prayer times: " + err.message);
    }
  };

  const handleEdit = (item) => {
    setEditMode(true);
    setEditData(item);
    setSelectedDate(item.date);
    setSelectedZone(item.zone);
    setSelectedCountry(item.country);
    setFormData(item.prayers);
    setError("");
  };

  const handleUpdate = async () => {
    if (!editData) return;

    try {
      const prayerTimesRef = ref(db, `prayerTimes/${selectedDate}/${selectedCountry}/${selectedZone}`);
      await set(prayerTimesRef, formData);

      setSuccess("Prayer times updated successfully!");
      setEditMode(false);
      setEditData(null);
      setFormData({
        fajr: { h: "", m: "" },
        sunrise: { h: "", m: "" },
        luhar: { h: "", m: "" },
        asr: { h: "", m: "" },
        maghrib: { h: "", m: "" },
        isha: { h: "", m: "" }
      });
      setSelectedDate("");
      setSelectedZone("");
      setError("");

      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to update prayer times: " + err.message);
    }
  };

  const handleDelete = async (item) => {
    if (!window.confirm("Delete this prayer time entry?")) return;

    try {
      const prayerTimesRef = ref(db, `prayerTimes/${item.date}/${item.country}/${item.zone}`);
      await remove(prayerTimesRef);
      setSuccess("Prayer times deleted successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to delete prayer times: " + err.message);
    }
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditData(null);
    setFormData({
      fajr: { h: "", m: "" },
      sunrise: { h: "", m: "" },
      luhar: { h: "", m: "" },
      asr: { h: "", m: "" },
      maghrib: { h: "", m: "" },
      isha: { h: "", m: "" }
    });
    setSelectedDate("");
    setSelectedZone("");
    setError("");
  };

  const handleSwapZonesClick = () => {
    setShowSwapSidebar(true);
    setSwapSourceZone("");
    setSwapTargetZone("");
    setSwapMonth("");
    setSwapYear(new Date().getFullYear().toString());
    setSwapEntries([]);
    setSwapCurrentDayIndex(0);
  };

  const handleCloseSwapSidebar = () => {
    setShowSwapSidebar(false);
  };

  useEffect(() => {
    if (showSwapSidebar && swapMonth && swapYear) {
      // Find entries for month/year (and source zone if selected)
      const formattedMonth = swapMonth.padStart(2, '0');

      const entries = prayerTimes.filter(pt => {
        const ptMonth = getMonthFromDate(pt.date);
        const ptYear = getYearFromDate(pt.date);
        const matchMonthYear = ptMonth === formattedMonth && ptYear === swapYear;
        if (!swapSourceZone) {
          return matchMonthYear;
        }
        return pt.zone === swapSourceZone && matchMonthYear;
      });
      // Sort entries by date ascending
      entries.sort((a, b) => {
        return a.date.localeCompare(b.date);
      });
      setSwapEntries(entries);
      setSwapCurrentDayIndex(0);
    } else {
      setSwapEntries([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swapMonth, swapYear, swapSourceZone, showSwapSidebar, prayerTimes]);

  const handleBulkDeleteFormat = async (format, entriesToDelete) => {
    if (!window.confirm(`Are you sure you want to delete all ${entriesToDelete.length} entries for the format ${format} in ${swapMonth}/${swapYear}?`)) {
      return;
    }

    try {
      const updates = {};
      for (const entry of entriesToDelete) {
        updates[`prayerTimes/${entry.date}/${entry.country}/${entry.zone}`] = null;
      }

      await update(ref(db), updates);

      setSuccess(`Successfully deleted ${entriesToDelete.length} entries with format ${format}!`);
      setTimeout(() => setSuccess(""), 3000);

      // Update swapEntries to exclude the deleted ones so UI updates instantly
      setSwapEntries(prev => prev.filter(e => !entriesToDelete.find(del => del.id === e.id)));
    } catch (err) {
      setError("Failed to delete entries: " + err.message);
    }
  };

  const handleSwapOrBulkUpdate = async (isSwap) => {
    if (!swapSourceZone || !swapTargetZone || !swapMonth || !swapYear) {
      setError("Please select source zone, target zone, month, and year.");
      return;
    }

    if (swapSourceZone === swapTargetZone) {
      setError("Source and Target zones must be different.");
      return;
    }

    if (swapEntries.length === 0) {
      setError("No entries found for the selected criteria.");
      return;
    }

    try {
      const updates = {};
      // Also need to get target zone entries if it's a swap
      let targetEntries = [];
      if (isSwap) {
        const formattedMonth = swapMonth.padStart(2, '0');
        targetEntries = prayerTimes.filter(pt => {
          const ptMonth = getMonthFromDate(pt.date);
          const ptYear = getYearFromDate(pt.date);
          return pt.zone === swapTargetZone && ptMonth === formattedMonth && ptYear === swapYear;
        });
      }

      // If bulk update (no swap), move source entries to target zone.
      // If swap, move source entries to target zone, and target entries to source zone.

      for (const entry of swapEntries) {
        updates[`prayerTimes/${entry.date}/${entry.country}/${swapTargetZone}`] = entry.prayers;
        if (!isSwap) {
          // In bulk update, delete the old source
          updates[`prayerTimes/${entry.date}/${entry.country}/${swapSourceZone}`] = null;
        }
      }

      if (isSwap) {
        for (const entry of targetEntries) {
          updates[`prayerTimes/${entry.date}/${entry.country}/${swapSourceZone}`] = entry.prayers;
        }
      }

      const rootRef = ref(db);
      await update(rootRef, updates);

      setSuccess(isSwap ? "Zones swapped successfully!" : "Zones bulk updated successfully!");
      setShowSwapSidebar(false);
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to update zones: " + err.message);
    }
  };

  const formatTime = (time) => {
    if (!time || time.h === null || time.m === null) return "--:--";
    return `${time.h.toString().padStart(2, '0')}:${time.m.toString().padStart(2, '0')}`;
  };

    const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const format = getDateFormat(dateStr);
    if (format === "YYYY-MM-DD") {
      const parts = dateStr.split('-');
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    if (format === "DD-MM-YYYY" || format === "DD-MM-YY") {
      const parts = dateStr.split('-');
      return `${parts[0]}/${parts[1]}/${parts[2].length === 2 ? "20" + parts[2] : parts[2]}`;
    }

    if (format === "YYMMDD") {
      const year = "20" + dateStr.substring(0, 2);
      const month = dateStr.substring(2, 4);
      const day = dateStr.substring(4, 6);
      return `${day}/${month}/${year}`;
    }

    // Default to DDMMYY
    const day = dateStr.substring(0, 2);
    const month = dateStr.substring(2, 4);
    const year = "20" + dateStr.substring(4, 6);
    return `${day}/${month}/${year}`;
  };

  // Extract month and year from date string
  const getMonthFromDate = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      if (parts[0].length === 4) return parts[1];
      return parts[1];
    }
    return dateStr.substring(2, 4);
  };

    const getDateFormat = (dateStr) => {
    if (!dateStr) return "Unknown";
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      if (parts[0].length === 4) return "YYYY-MM-DD";
      return "DD-MM-YYYY";
    }
    const p1 = parseInt(dateStr.substring(0, 2), 10);
    const p3 = parseInt(dateStr.substring(4, 6), 10);

    const yearDD = 2000 + p3;
    const yearYY = 2000 + p1;

    const currentYear = new Date().getFullYear();
    const diffDD = Math.abs(yearDD - currentYear);
    const diffYY = Math.abs(yearYY - currentYear);

    const isValidDayDD = p1 >= 1 && p1 <= 31;
    const isValidDayYY = p3 >= 1 && p3 <= 31;

    if (isValidDayDD && !isValidDayYY) return "DDMMYY";
    if (isValidDayYY && !isValidDayDD) return "YYMMDD";

    if (diffYY < diffDD) {
      return "YYMMDD";
    } else if (diffDD < diffYY) {
      return "DDMMYY";
    } else {
      return "DDMMYY";
    }
  };

    const getYearFromDate = (dateStr) => {
    if (!dateStr) return "";
    const format = getDateFormat(dateStr);
    if (format === "YYYY-MM-DD") return dateStr.split('-')[0];
    if (format === "DD-MM-YYYY" || format === "DD-MM-YY") {
        const p = dateStr.split('-')[2];
        return p.length === 2 ? "20" + p : p;
    }
    if (format === "YYMMDD") return "20" + dateStr.substring(0, 2);
    return "20" + dateStr.substring(4, 6);
  };

  // Sorting function
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortDirection("asc");
    }
  };

  // Sort data
  const sortData = (data) => {
    return data.sort((a, b) => {
      let aValue, bValue;

      switch (sortKey) {
        case "date":
          aValue = a.date;
          bValue = b.date;
          break;
        case "zone":
          aValue = zones.find(z => z.key === a.zone)?.title || a.zone;
          bValue = zones.find(z => z.key === b.zone)?.title || b.zone;
          break;
        case "country":
          aValue = a.country;
          bValue = b.country;
          break;
        case "fajr":
          aValue = formatTime(a.prayers.fajr);
          bValue = formatTime(b.prayers.fajr);
          break;
        case "sunrise":
          aValue = formatTime(a.prayers.sunrise);
          bValue = formatTime(b.prayers.sunrise);
          break;
        case "luhar":
          aValue = formatTime(a.prayers.luhar);
          bValue = formatTime(b.prayers.luhar);
          break;
        case "asr":
          aValue = formatTime(a.prayers.asr);
          bValue = formatTime(b.prayers.asr);
          break;
        case "maghrib":
          aValue = formatTime(a.prayers.maghrib);
          bValue = formatTime(b.prayers.maghrib);
          break;
        case "isha":
          aValue = formatTime(a.prayers.isha);
          bValue = formatTime(b.prayers.isha);
          break;
        default:
          aValue = a[sortKey];
          bValue = b[sortKey];
      }

      if (sortDirection === "asc") {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });
  };

  // Filter and sort data
  const filteredPrayerTimes = sortData(prayerTimes.filter(item => {
    const matchesSearch = item.date.includes(search) ||
      item.zone.toLowerCase().includes(search.toLowerCase()) ||
      item.country.toLowerCase().includes(search.toLowerCase());

    const matchesZone = !filterZone || item.zone === filterZone;
    const matchesMonth = !filterMonth || getMonthFromDate(item.date) === filterMonth;
    const matchesYear = !filterYear || getYearFromDate(item.date) === filterYear;

    return matchesSearch && matchesZone && matchesMonth && matchesYear;
  }));

  return (
    <div>
      <div style={{ marginBottom: "1.5rem", padding: "1rem", border: "1px solid #e5e7eb", borderRadius: 8 }}>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={usePreviousYear}
            onChange={(e) => handleToggleUsePreviousYear(e.target.checked)}
            style={{ margin: 0 }}
          />
          <span>Use previous year for 2026 prayer times</span>
        </label>
        <small style={{ display: "block", marginTop: "0.25rem", color: "#666" }}>
          When enabled, viewing a 2026 date on the public site loads 2025 prayer times (same day and month).
        </small>
      </div>

      {!editMode && (
        <>
          <h3>Add New Prayer Times</h3>

          <div className="form-row">
            <input
              type="text"
              placeholder="Date (DDMMYY format, e.g., 100525)"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
            <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="LK">Sri Lanka (LK)</option>
            </select>
            <select
              value={selectedZone}
              onChange={(e) => setSelectedZone(e.target.value)}
            >
              <option value="">Select Zone</option>
              {zones.map(zone => (
                <option key={zone.key} value={zone.key}>
                  {zone.title}
                </option>
              ))}
            </select>
          </div>

          <div className="prayer-times-form">
            <h4>Prayer Times (24-hour format)</h4>
            <div className="prayer-times-grid">
              {[
                { key: 'fajr', label: 'Fajr' },
                { key: 'sunrise', label: 'Sunrise' },
                { key: 'luhar', label: 'Luhar' },
                { key: 'asr', label: 'Asr' },
                { key: 'maghrib', label: 'Maghrib' },
                { key: 'isha', label: 'Isha' }
              ].map(prayer => (
                <div key={prayer.key} className="prayer-time-input">
                  <label>{prayer.label}</label>
                  <div className="time-inputs">
                    <input
                      type="number"
                      placeholder="HH"
                      min="0"
                      max="23"
                      value={formData[prayer.key].h}
                      onChange={(e) => setFormData({
                        ...formData,
                        [prayer.key]: { ...formData[prayer.key], h: e.target.value }
                      })}
                    />
                    <span>:</span>
                    <input
                      type="number"
                      placeholder="MM"
                      min="0"
                      max="59"
                      value={formData[prayer.key].m}
                      onChange={(e) => setFormData({
                        ...formData,
                        [prayer.key]: { ...formData[prayer.key], m: e.target.value }
                      })}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="form-actions">
            <button className="primary" onClick={handleAdd}>Add Prayer Times</button>
          </div>

          {error && <div className="form-error">{error}</div>}
          {success && <div className="form-success">{success}</div>}
        </>
      )}

      {/* Edit Sidebar */}
      {editMode && (
        <div className="sidebar-overlay" onClick={handleCancel}>
          <div className="sidebar-content" onClick={e => e.stopPropagation()}>
            <div className="sidebar-header">
              <h3>Edit Prayer Times</h3>
              <button className="close-btn" onClick={handleCancel}>&times;</button>
            </div>
            <div className="sidebar-body">
              <div className="form-row">
                <input
                  type="text"
                  placeholder="Date"
                  value={selectedDate}
                  disabled
                />
                <select value={selectedCountry} disabled>
                  <option value="LK">Sri Lanka (LK)</option>
                </select>
                <select value={selectedZone} disabled>
                  <option value="">Select Zone</option>
                  {zones.map(zone => (
                    <option key={zone.key} value={zone.key}>
                      {zone.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="prayer-times-form">
                <h4>Prayer Times (24-hour format)</h4>
                <div className="prayer-times-grid">
                  {[
                    { key: 'fajr', label: 'Fajr' },
                    { key: 'sunrise', label: 'Sunrise' },
                    { key: 'luhar', label: 'Luhar' },
                    { key: 'asr', label: 'Asr' },
                    { key: 'maghrib', label: 'Maghrib' },
                    { key: 'isha', label: 'Isha' }
                  ].map(prayer => (
                    <div key={prayer.key} className="prayer-time-input">
                      <label>{prayer.label}</label>
                      <div className="time-inputs">
                        <input
                          type="number"
                          placeholder="HH"
                          min="0"
                          max="23"
                          value={formData[prayer.key].h}
                          onChange={(e) => setFormData({
                            ...formData,
                            [prayer.key]: { ...formData[prayer.key], h: e.target.value }
                          })}
                        />
                        <span>:</span>
                        <input
                          type="number"
                          placeholder="MM"
                          min="0"
                          max="59"
                          value={formData[prayer.key].m}
                          onChange={(e) => setFormData({
                            ...formData,
                            [prayer.key]: { ...formData[prayer.key], m: e.target.value }
                          })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="sidebar-footer">
              <button className="primary" onClick={handleUpdate}>Update</button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
      )}


      {/* Swap/Bulk Update Sidebar */}
      {showSwapSidebar && (
        <div className="sidebar-overlay" onClick={handleCloseSwapSidebar}>
          <div className="sidebar-content" style={{ width: '500px' }} onClick={e => e.stopPropagation()}>
            <div className="sidebar-header">
              <h3>Advanced Settings</h3>
              <button className="close-btn" onClick={handleCloseSwapSidebar}>&times;</button>
            </div>
            <div className="sidebar-body">
              <div className="form-row">
                <select value={swapMonth} onChange={e => setSwapMonth(e.target.value)}>
                  <option value="">Select Month</option>
                  <option value="01">January</option>
                  <option value="02">February</option>
                  <option value="03">March</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">August</option>
                  <option value="09">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                <input
                  type="text"
                  placeholder="Year (e.g. 2024)"
                  value={swapYear}
                  onChange={e => setSwapYear(e.target.value)}
                />
              </div>
              <div className="form-row">
                <select value={swapSourceZone} onChange={e => setSwapSourceZone(e.target.value)}>
                  <option value="">Select Source Zone</option>
                  {zones.map(z => <option key={z.key} value={z.key}>{z.title}</option>)}
                </select>
                <span style={{alignSelf: 'center'}}>➜</span>
                <select value={swapTargetZone} onChange={e => setSwapTargetZone(e.target.value)}>
                  <option value="">Select Target Zone</option>
                  {zones.map(z => <option key={z.key} value={z.key}>{z.title}</option>)}
                </select>
              </div>

              {swapEntries.length > 0 && (() => {
                const formatGroups = {};
                swapEntries.forEach(entry => {
                  const format = getDateFormat(entry.date);
                  if (!formatGroups[format]) formatGroups[format] = [];
                  formatGroups[format].push(entry);
                });

                return Object.entries(formatGroups).map(([format, entries], idx) => (
                  <div key={format} style={{ marginTop: 20, padding: 10, border: '1px solid #ccc', borderRadius: 8 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h4>Format: {format} ({entries.length} entries)</h4>
                      <button className="danger" onClick={() => handleBulkDeleteFormat(format, entries)}>
                        Delete Format Entries
                      </button>
                    </div>
                    {/* Render the first entry of this format group just to preview */}
                    <div style={{ marginTop: 10 }}>
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Prayer</th>
                            <th>Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {['fajr', 'sunrise', 'luhar', 'asr', 'maghrib', 'isha'].map((prayer, pIdx) => (
                            <tr key={prayer}>
                              {pIdx === 0 && <td rowSpan={6} style={{verticalAlign: 'top'}}>
                                {formatDate(entries[0].date)}<br/>
                                {entries[0].zone && <small>Zone: {entries[0].zone}</small>}
                              </td>}
                              <td style={{ textTransform: 'capitalize' }}>{prayer}</td>
                              <td>{formatTime(entries[0].prayers[prayer])}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ));
              })()}
            </div>
            <div className="sidebar-footer">
              <button className="primary" onClick={() => handleSwapOrBulkUpdate(true)}>Swap Zones</button>
              <button className="primary" onClick={() => handleSwapOrBulkUpdate(false)}>Bulk Update</button>
              <button onClick={handleCloseSwapSidebar}>Cancel</button>
            </div>
          </div>
        </div>
      )}



      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ marginTop: 24, marginBottom: 24 }}>Existing Prayer Times</h3>
        <button className="primary" onClick={handleSwapZonesClick}>Advanced Settings</button>
      </div>

      {/* Filter Controls */}
      <div className="filter-controls">
        <input
          type="text"
          className="search-input"
          placeholder="Search by date, zone, or country..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          value={filterZone}
          onChange={(e) => setFilterZone(e.target.value)}
          className="filter-select"
        >
          <option value="">All Zones</option>
          {zones.map(zone => (
            <option key={zone.key} value={zone.key}>
              {zone.title}
            </option>
          ))}
        </select>

        <select
          value={filterMonth}
          onChange={(e) => setFilterMonth(e.target.value)}
          className="filter-select"
        >
          <option value="">All Months</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>

        <select
          value={filterYear}
          onChange={(e) => setFilterYear(e.target.value)}
          className="filter-select"
        >
          <option value="">All Years</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
        </select>
      </div>

      <div className="table-wrap">
        <table className="modern-table">
          <thead>
            <tr>
              <th
                className="sortable-header"
                onClick={() => handleSort("date")}
              >
                Date
                <span className={`sort-indicator ${sortKey === "date" ? sortDirection : ""}`}>
                  {sortKey === "date" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th>Format</th>
              <th
                className="sortable-header"
                onClick={() => handleSort("country")}
              >
                Country
                <span className={`sort-indicator ${sortKey === "country" ? sortDirection : ""}`}>
                  {sortKey === "country" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("zone")}
              >
                Zone
                <span className={`sort-indicator ${sortKey === "zone" ? sortDirection : ""}`}>
                  {sortKey === "zone" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("fajr")}
              >
                Fajr
                <span className={`sort-indicator ${sortKey === "fajr" ? sortDirection : ""}`}>
                  {sortKey === "fajr" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("sunrise")}
              >
                Sunrise
                <span className={`sort-indicator ${sortKey === "sunrise" ? sortDirection : ""}`}>
                  {sortKey === "sunrise" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("luhar")}
              >
                Luhar
                <span className={`sort-indicator ${sortKey === "luhar" ? sortDirection : ""}`}>
                  {sortKey === "luhar" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("asr")}
              >
                Asr
                <span className={`sort-indicator ${sortKey === "asr" ? sortDirection : ""}`}>
                  {sortKey === "asr" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("maghrib")}
              >
                Maghrib
                <span className={`sort-indicator ${sortKey === "maghrib" ? sortDirection : ""}`}>
                  {sortKey === "maghrib" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("isha")}
              >
                Isha
                <span className={`sort-indicator ${sortKey === "isha" ? sortDirection : ""}`}>
                  {sortKey === "isha" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPrayerTimes.length === 0 && (
              <tr><td colSpan={10}>No prayer times found.</td></tr>
            )}
            {filteredPrayerTimes.map((item) => (
              <tr key={item.id}>
                <td>{formatDate(item.date)}</td>
                <td>{getDateFormat(item.date)}</td>
                <td>{item.country}</td>
                <td>{zones.find(z => z.key === item.zone)?.title || item.zone}</td>
                <td>{formatTime(item.prayers.fajr)}</td>
                <td>{formatTime(item.prayers.sunrise)}</td>
                <td>{formatTime(item.prayers.luhar)}</td>
                <td>{formatTime(item.prayers.asr)}</td>
                <td>{formatTime(item.prayers.maghrib)}</td>
                <td>{formatTime(item.prayers.isha)}</td>
                <td>
                  <button onClick={() => handleEdit(item)}>Edit</button>
                  <button className="danger" onClick={() => handleDelete(item)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ManageAreas({ areas, setAreas }) {
  const [search, setSearch] = useState("");
  const [key, setKey] = useState("");
  const [name, setName] = useState("");
  const [editIdx, setEditIdx] = useState(null);
  const [editKey, setEditKey] = useState("");
  const [editName, setEditName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const areasRef = ref(db, "zones/areas");
    const unsubscribe = onValue(areasRef, (snapshot) => {
      const data = snapshot.val() || {};
      setAreas(Object.entries(data).map(([key, name]) => ({ key, name })));
    });
    return () => unsubscribe();
  }, [setAreas]);

  const addArea = async () => {
    if (!key.trim() || !name.trim()) {
      setError("Please enter both key and name.");
      return;
    }
    if (areas.some(a => a.key === key)) {
      setError("Key must be unique.");
      return;
    }
    await set(ref(db, `zones/areas/${key}`), name);
    setKey("");
    setName("");
    setError("");
  };

  const handleEdit = idx => {
    setEditIdx(idx);
    setEditKey(areas[idx].key);
    setEditName(areas[idx].name);
  };

  const handleEditSave = async idx => {
    if (!editKey.trim() || !editName.trim()) {
      setError("Please enter both key and name.");
      return;
    }
    if (areas.some((a, i) => a.key === editKey && i !== idx)) {
      setError("Key must be unique.");
      return;
    }
    await set(ref(db, `zones/areas/${editKey}`), editName);
    setEditIdx(null);
    setEditKey("");
    setEditName("");
    setError("");
  };

  const handleDelete = async idx => {
    if (window.confirm("Delete this area?")) {
      await remove(ref(db, `zones/areas/${areas[idx].key}`));
    }
  };

  const filtered = areas.filter(a =>
    a.key.toLowerCase().includes(search.toLowerCase()) ||
    a.name.toLowerCase().includes(search.toLowerCase())
  );

  const areaOptions = areas.map(a => ({
    value: a.key,
    label: a.name
  }));

  return (
    <div>
      <h3>Add New Area</h3>
      <div className="form-row">
        <input type="text" placeholder="Area Key" value={key} onChange={e => setKey(e.target.value)} />
        <input type="text" placeholder="Area Name" value={name} onChange={e => setName(e.target.value)} />
        <button className="primary" onClick={addArea}>Add</button>
      </div>
      {error && <div className="form-error">{error}</div>}
      <h3 style={{ marginTop: 24 }}>Areas List</h3>
      <div style={{ marginBottom: '1rem' }}>
        <Select
          options={areaOptions}
          placeholder="Search areas..."
          isClearable
          onChange={option => setSearch(option ? option.label : '')}
          styles={{
            control: (base) => ({
              ...base,
              minHeight: '38px',
              borderRadius: '8px',
              border: '1px solid #d3dbe3',
            }),
          }}
        />
      </div>
      <div className="table-wrap">
        <table className="modern-table">
          <thead>
            <tr>
              <th>Key</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={3}>No areas found.</td></tr>
            )}
            {filtered.map((a, idx) => (
              <tr key={a.key}>
                <td>{editIdx === idx ? <input value={editKey} onChange={e => setEditKey(e.target.value)} /> : a.key}</td>
                <td>{editIdx === idx ? <input value={editName} onChange={e => setEditName(e.target.value)} /> : a.name}</td>
                <td>
                  {editIdx === idx ? (
                    <>
                      <button className="primary" onClick={() => handleEditSave(idx)}>Save</button>
                      <button onClick={() => setEditIdx(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => handleEdit(idx)}>Edit</button>
                      <button className="danger" onClick={() => handleDelete(idx)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ManageZones({ areas }) {
  const [zones, setZones] = useState([]);
  const [search, setSearch] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [title, setTitle] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [order, setOrder] = useState(1);
  const [editIdx, setEditIdx] = useState(null);
  const [editZoneName, setEditZoneName] = useState("");
  const [editTitle, setEditTitle] = useState("");
  const [editSelectedAreas, setEditSelectedAreas] = useState([]);
  const [editOrder, setEditOrder] = useState(1);
  const [error, setError] = useState("");

  // Sorting states
  const [sortKey, setSortKey] = useState("order");
  const [sortDirection, setSortDirection] = useState("asc");


  useEffect(() => {
    const zonesRef = ref(db, "zones");
    const unsubscribe = onValue(zonesRef, (snapshot) => {
      const data = snapshot.val() || {};
      const zonesList = [];
      Object.entries(data).forEach(([key, zoneData]) => {
        if (key !== "areas") { // Skip the areas node
          const areasArray = zoneData.areas ? Object.values(zoneData.areas) : [];
          zonesList.push({
            key,
            title: zoneData.title || "",
            areas: areasArray,
            order: zoneData.order || 1
          });
        }
      });
      setZones(zonesList);
    });
    return () => unsubscribe();
  }, []);

  const addZone = async () => {
    if (!zoneName.trim() || !title.trim() || selectedAreas.length === 0) {
      setError("Please enter zone name, title and select at least one area.");
      return;
    }
    if (zones.some(z => z.key === zoneName)) {
      setError("Zone name must be unique.");
      return;
    }

    const areasObject = {};
    selectedAreas.forEach((area, index) => {
      areasObject[index] = area.value;
    });

    await set(ref(db, `zones/${zoneName}`), {
      areas: areasObject,
      order: parseInt(order),
      title: title.trim()
    });

    setZoneName("");
    setTitle("");
    setSelectedAreas([]);
    setOrder(1);
    setError("");
  };

  const handleEdit = idx => {
    setEditIdx(idx);
    setEditZoneName(zones[idx].key);
    setEditTitle(zones[idx].title);
    setEditSelectedAreas(zones[idx].areas.map(areaKey => {
      const area = areas.find(a => a.key === areaKey);
      return area ? { value: area.key, label: area.name } : null;
    }).filter(Boolean));
    setEditOrder(zones[idx].order);
  };

  const handleEditSave = async idx => {
    if (!editTitle.trim() || editSelectedAreas.length === 0) {
      setError("Please enter title and select at least one area.");
      return;
    }

    const areasObject = {};
    editSelectedAreas.forEach((area, index) => {
      areasObject[index] = area.value;
    });

    await set(ref(db, `zones/${editZoneName}`), {
      areas: areasObject,
      order: parseInt(editOrder),
      title: editTitle.trim()
    });

    setEditIdx(null);
    setEditZoneName("");
    setEditTitle("");
    setEditSelectedAreas([]);
    setEditOrder(1);
    setError("");
  };

  const handleDelete = async idx => {
    if (window.confirm("Delete this zone?")) {
      await remove(ref(db, `zones/${zones[idx].key}`));
    }
  };

  // Sorting function
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortDirection("asc");
    }
  };

  // Sort data
  const sortData = (data) => {
    return data.sort((a, b) => {
      let aValue, bValue;

      switch (sortKey) {
        case "key":
          aValue = a.key;
          bValue = b.key;
          break;
        case "title":
          aValue = a.title;
          bValue = b.title;
          break;
        case "order":
          aValue = a.order;
          bValue = b.order;
          break;
        case "areas":
          aValue = getAreaNames(a.areas);
          bValue = getAreaNames(b.areas);
          break;
        default:
          aValue = a[sortKey];
          bValue = b[sortKey];
      }

      if (sortDirection === "asc") {
        return aValue.localeCompare ? aValue.localeCompare(bValue) : aValue - bValue;
      } else {
        return bValue.localeCompare ? bValue.localeCompare(aValue) : bValue - aValue;
      }
    });
  };

  const filtered = sortData(zones.filter(z =>
    z.title.toLowerCase().includes(search.toLowerCase()) ||
    z.areas.some(a => a.toLowerCase().includes(search.toLowerCase()))
  ));

  // Helper function to get area names from area keys
  const getAreaNames = (areaKeys) => {
    return areaKeys.map(areaKey => {
      const area = areas.find(a => a.key === areaKey);
      return area ? area.name : areaKey;
    }).join(", ");
  };

  const areaOptions = areas.map(area => ({
    value: area.key,
    label: area.name
  }));

  return (
    <div>
      <h3>Add New Zone</h3>
      <div className="form-row">
        <input
          type="text"
          placeholder="Zone Name (e.g., Z4_COL_GAM_KAL)"
          value={zoneName}
          onChange={e => setZoneName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Zone Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <Select
          isMulti
          placeholder="Select Areas"
          value={selectedAreas}
          onChange={setSelectedAreas}
          options={areaOptions}
          className="react-select-container"
          classNamePrefix="react-select"
        />
        <input
          type="number"
          placeholder="Sort Order"
          value={order}
          onChange={e => setOrder(e.target.value)}
          min="1"
        />
        <button className="primary" onClick={addZone}>Add</button>
      </div>
      {error && <div className="form-error">{error}</div>}
      <h3 style={{ marginTop: 24 }}>Zones List</h3>
      <input
        type="text"
        className="search-input"
        placeholder="Search zones..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <div className="table-wrap">
        <table className="modern-table">
          <thead>
            <tr>
              <th
                className="sortable-header"
                onClick={() => handleSort("key")}
              >
                Zone Name
                <span className={`sort-indicator ${sortKey === "key" ? sortDirection : ""}`}>
                  {sortKey === "key" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("title")}
              >
                Title
                <span className={`sort-indicator ${sortKey === "title" ? sortDirection : ""}`}>
                  {sortKey === "title" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("areas")}
              >
                Areas
                <span className={`sort-indicator ${sortKey === "areas" ? sortDirection : ""}`}>
                  {sortKey === "areas" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort("order")}
              >
                Order
                <span className={`sort-indicator ${sortKey === "order" ? sortDirection : ""}`}>
                  {sortKey === "order" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                </span>
              </th>
              <th style={{ width: 100 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={5}>No zones found.</td></tr>
            )}
            {filtered.map((z, idx) => (
              <tr key={z.key}>
                <td>{z.key}</td>
                <td>
                  {editIdx === idx ? (
                    <input value={editTitle} onChange={e => setEditTitle(e.target.value)} />
                  ) : (
                    z.title
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <Select
                      isMulti
                      placeholder="Select Areas"
                      value={editSelectedAreas}
                      onChange={setEditSelectedAreas}
                      options={areaOptions}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  ) : (
                    getAreaNames(z.areas)
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <input
                      type="number"
                      value={editOrder}
                      onChange={e => setEditOrder(e.target.value)}
                      min="1"
                    />
                  ) : (
                    z.order
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <>
                      <button className="primary" onClick={() => handleEditSave(idx)}>Save</button>
                      <button onClick={() => setEditIdx(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => handleEdit(idx)}>Edit</button>
                      <button className="danger" onClick={() => handleDelete(idx)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ManageMeta() {
  const [metaList, setMetaList] = useState([]);
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: 'date',
    direction: 'asc'
  });

  const [form, setForm] = useState({
    date: "",
    country: "LK",
    yearGregorian: "",
    monthGregorian: "",
    dayGregorian: "",
    dayNameEn: "",
    yearHijri: "",
    monthHijri: "",
    dayHijri: "",
    dayNameArabic: "",
    event: "",
    isTentative: false
  });
  const [editIdx, setEditIdx] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    const metaRef = ref(db, "meta");
    const unsubscribe = onValue(metaRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = [];
      Object.entries(data).forEach(([date, countries]) => {
        Object.entries(countries).forEach(([country, fields]) => {
          list.push({ date, country, ...fields });
        });
      });
      setMetaList(list);
    });
    return () => unsubscribe();
  }, []);

  const handleDateChange = (e) => {
    const date = e.target.value;
    if (!date) {
      setForm(prev => ({ ...prev, date: "" }));
      return;
    }

    const [year, month, day] = date.split("-").map(Number);
    const dateObj = new Date(year, month - 1, day);
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const arabicWeekdays = ["Yawmul Ahad", "Yawmul Ithnayn", "Yawmul Thulatha", "Yawmul Arba'a", "Yawmul Khamees", "Yawmul Jumu'ah", "Yawmul Sabt"];

    // TODO: Add proper Hijri date conversion here
    const hijriYear = 1447;
    const hijriMonth = "Dhul Qa'dah";
    const hijriDay = 19;

    setForm(prev => ({
      ...prev,
      date: `${day.toString().padStart(2, '0')}${month.toString().padStart(2, '0')}${year.toString().slice(-2)}`,
      yearGregorian: year,
      monthGregorian: dateObj.toLocaleString('default', { month: 'long' }),
      dayGregorian: day,
      dayNameEn: weekdays[dateObj.getDay()],
      yearHijri: hijriYear,
      monthHijri: hijriMonth,
      dayHijri: hijriDay,
      dayNameArabic: arabicWeekdays[dateObj.getDay()],
      event: prev.event,
      isTentative: prev.isTentative
    }));
  };

  const handleAdd = async () => {
    if (!form.date || !form.yearGregorian || !form.monthGregorian) {
      setError("Please fill all required fields.");
      return;
    }
    await set(ref(db, `meta/${form.date}/${form.country}`), {
      yearGregorian: form.yearGregorian,
      monthGregorian: form.monthGregorian,
      dayGregorian: form.dayGregorian,
      dayNameEn: form.dayNameEn,
      yearHijri: form.yearHijri,
      monthHijri: form.monthHijri,
      dayHijri: form.dayHijri,
      dayNameArabic: form.dayNameArabic,
      event: form.event,
      isTentative: form.isTentative
    });
    setForm({
      date: "",
      country: "LK",
      yearGregorian: "",
      monthGregorian: "",
      dayGregorian: "",
      dayNameEn: "",
      yearHijri: "",
      monthHijri: "",
      dayHijri: "",
      dayNameArabic: "",
      event: "",
      isTentative: false
    });
    setError("");
  };

  const handleAddAndNew = async () => {
    if (!form.date || !form.yearGregorian || !form.monthGregorian) {
      setError("Please fill all required fields.");
      return;
    }

    // Save current data
    await set(ref(db, `meta/${form.date}/${form.country}`), {
      yearGregorian: form.yearGregorian,
      monthGregorian: form.monthGregorian,
      dayGregorian: form.dayGregorian,
      dayNameEn: form.dayNameEn,
      yearHijri: form.yearHijri,
      monthHijri: form.monthHijri,
      dayHijri: form.dayHijri,
      dayNameArabic: form.dayNameArabic,
      event: form.event,
      isTentative: form.isTentative
    });

    // Increment Gregorian date by 1 day
    const currentDate = new Date(form.yearGregorian, new Date(form.monthGregorian + " 1").getMonth(), form.dayGregorian);
    currentDate.setDate(currentDate.getDate() + 1);

    const newYear = currentDate.getFullYear();
    const newMonth = currentDate.toLocaleString('default', { month: 'long' });
    const newDay = currentDate.getDate();
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const arabicWeekdays = ["Yawmul Ahad", "Yawmul Ithnayn", "Yawmul Thulatha", "Yawmul Arba'a", "Yawmul Khamees", "Yawmul Jumu'ah", "Yawmul Sabt"];

    // Increment Hijri date by 1 day (simple increment for now)
    const newHijriDay = parseInt(form.dayHijri) + 1;
    const newHijriYear = parseInt(form.yearHijri);
    const newHijriMonth = form.monthHijri; // Keep same month for now

    // Update form with incremented dates
    setForm(prev => ({
      ...prev,
      date: `${newDay.toString().padStart(2, '0')}${(currentDate.getMonth() + 1).toString().padStart(2, '0')}${newYear.toString().slice(-2)}`,
      yearGregorian: newYear,
      monthGregorian: newMonth,
      dayGregorian: newDay,
      dayNameEn: weekdays[currentDate.getDay()],
      yearHijri: newHijriYear,
      monthHijri: newHijriMonth,
      dayHijri: newHijriDay,
      dayNameArabic: arabicWeekdays[currentDate.getDay()],
      event: "",
      isTentative: false
    }));

    setError("");

    // Focus on Hijri year field after a short delay
    setTimeout(() => {
      const hijriYearInput = document.querySelector('input[placeholder="Year (Hijri)"]');
      if (hijriYearInput) {
        hijriYearInput.focus();
      }
    }, 100);
  };

  const handleEdit = (item, idx) => {
    setEditIdx(idx);
    setEditForm({ ...item });
  };

  const handleEditSave = async idx => {
    if (!editForm.date || !editForm.yearGregorian || !editForm.monthGregorian) {
      setError("Please fill all required fields.");
      return;
    }
    await set(ref(db, `meta/${editForm.date}/${editForm.country}`), {
      yearGregorian: editForm.yearGregorian,
      monthGregorian: editForm.monthGregorian,
      dayGregorian: editForm.dayGregorian,
      dayNameEn: editForm.dayNameEn,
      yearHijri: editForm.yearHijri,
      monthHijri: editForm.monthHijri,
      dayHijri: editForm.dayHijri,
      dayNameArabic: editForm.dayNameArabic,
      event: editForm.event || "",
      isTentative: editForm.isTentative || false
    });
    setEditIdx(null);
    setEditForm({});
    setError("");
  };

  const handleDelete = async (item) => {
    if (window.confirm("Delete this meta data?")) {
      await remove(ref(db, `meta/${item.date}/${item.country}`));
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortData = (data) => {
    return data.sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle date sorting (convert to comparable format)
      if (sortConfig.key === 'date') {
        aValue = aValue || '';
        bValue = bValue || '';
      }

      // Handle numeric values
      if (sortConfig.key === 'dayGregorian' || sortConfig.key === 'yearGregorian' ||
        sortConfig.key === 'dayHijri' || sortConfig.key === 'yearHijri') {
        aValue = parseInt(aValue) || 0;
        bValue = parseInt(bValue) || 0;
      }

      // Handle boolean values
      if (sortConfig.key === 'isTentative') {
        aValue = aValue ? 1 : 0;
        bValue = bValue ? 1 : 0;
      }

      // Handle empty values
      if (!aValue && aValue !== 0) aValue = '';
      if (!bValue && bValue !== 0) bValue = '';

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  const filtered = metaList.filter(m =>
    m.date.includes(search) ||
    m.monthGregorian.toLowerCase().includes(search.toLowerCase()) ||
    m.dayNameEn.toLowerCase().includes(search.toLowerCase()) ||
    (m.event && m.event.toLowerCase().includes(search.toLowerCase()))
  );

  const sortedData = sortData([...filtered]);

  return (
    <div>
      <h3>Add New Meta Data</h3>
      <div className="form-grid">
        <div className="form-row">
          <input
            type="date"
            value={form.date ? `${form.yearGregorian}-${form.monthGregorian ? new Date(0, new Date(form.monthGregorian + " 1").getMonth()).getMonth() + 1 : ''}-${form.dayGregorian}` : ''}
            onChange={handleDateChange}
            placeholder="Select Date"
          />
          <input
            type="text"
            placeholder="Country"
            value={form.country}
            onChange={e => setForm(f => ({ ...f, country: e.target.value }))}
          />
        </div>

        <div className="form-row">
          <input type="number" placeholder="Year (Gregorian)" value={form.yearGregorian} readOnly />
          <input type="text" placeholder="Month (Gregorian)" value={form.monthGregorian} readOnly />
          <input type="number" placeholder="Day (Gregorian)" value={form.dayGregorian} readOnly />
          <input type="text" placeholder="Day Name (En)" value={form.dayNameEn} readOnly />
        </div>

        <div className="form-row">
          <input type="number" placeholder="Year (Hijri)" value={form.yearHijri} onChange={e => setForm(f => ({ ...f, yearHijri: e.target.value }))} />
          <select
            value={form.monthHijri}
            onChange={e => setForm(f => ({ ...f, monthHijri: e.target.value }))}
            className="hijri-month-select"
          >
            <option value="">Select Hijri Month</option>
            {HIJRI_MONTHS.map((month, index) => (
              <option key={index} value={month}>{month}</option>
            ))}
          </select>
          <input type="number" placeholder="Day (Hijri)" value={form.dayHijri} onChange={e => setForm(f => ({ ...f, dayHijri: e.target.value }))} />
          <input type="text" placeholder="Day Name (Arabic)" value={form.dayNameArabic} readOnly />
        </div>

        <div className="form-row">
          <input
            type="text"
            placeholder="Event (optional)"
            value={form.event}
            onChange={e => setForm(f => ({ ...f, event: e.target.value }))}
          />
          <div className="checkbox-container">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={form.isTentative}
                onChange={e => setForm(f => ({ ...f, isTentative: e.target.checked }))}
              />
              <span className="checkmark"></span>
              Is Tentative
            </label>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 8, display: 'flex', gap: '0.5rem' }}>
        <button className="primary" onClick={handleAdd}>Add</button>
        <button className="primary" onClick={handleAddAndNew}>Add & New</button>
      </div>
      {error && <div className="form-error">{error}</div>}
      <h3 style={{ marginTop: 24 }}>Meta Data List</h3>
      <input
        type="text"
        className="search-input"
        placeholder="Search meta..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <div className="table-wrap">
        <table className="modern-table">
          <thead>
            <tr>
              <th
                className="sortable-header"
                onClick={() => handleSort('date')}
                title="Click to sort by Date"
              >
                Date
                <span className={`sort-indicator ${sortConfig.key === 'date' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'date' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('country')}
                title="Click to sort by Country"
              >
                Country
                <span className={`sort-indicator ${sortConfig.key === 'country' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'country' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('monthGregorian')}
                title="Click to sort by Gregorian Month"
              >
                Gregorian
                <span className={`sort-indicator ${sortConfig.key === 'monthGregorian' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'monthGregorian' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('monthHijri')}
                title="Click to sort by Hijri Month"
              >
                Hijri
                <span className={`sort-indicator ${sortConfig.key === 'monthHijri' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'monthHijri' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('dayNameEn')}
                title="Click to sort by Day Name"
              >
                Day Name (En)
                <span className={`sort-indicator ${sortConfig.key === 'dayNameEn' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'dayNameEn' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('dayNameArabic')}
                title="Click to sort by Arabic Day Name"
              >
                Day Name (Ar)
                <span className={`sort-indicator ${sortConfig.key === 'dayNameArabic' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'dayNameArabic' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('event')}
                title="Click to sort by Event"
              >
                Event
                <span className={`sort-indicator ${sortConfig.key === 'event' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'event' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th
                className="sortable-header"
                onClick={() => handleSort('isTentative')}
                title="Click to sort by Tentative Status"
              >
                Tentative
                <span className={`sort-indicator ${sortConfig.key === 'isTentative' ? sortConfig.direction : ''}`}>
                  {sortConfig.key === 'isTentative' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
                </span>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.length === 0 && (
              <tr><td colSpan={9}>No meta data found.</td></tr>
            )}
            {sortedData.map((m, idx) => (
              <tr key={idx}>
                <td>{editIdx === idx ? <input value={editForm.date} onChange={e => setEditForm(f => ({ ...f, date: e.target.value }))} /> : m.date}</td>
                <td>{editIdx === idx ? <input value={editForm.country} onChange={e => setEditForm(f => ({ ...f, country: e.target.value }))} /> : m.country}</td>
                <td>
                  {editIdx === idx ? (
                    <div className="edit-group">
                      <input value={editForm.dayGregorian} onChange={e => setEditForm(f => ({ ...f, dayGregorian: e.target.value }))} placeholder="Day" />
                      <input value={editForm.monthGregorian} onChange={e => setEditForm(f => ({ ...f, monthGregorian: e.target.value }))} placeholder="Month" />
                      <input value={editForm.yearGregorian} onChange={e => setEditForm(f => ({ ...f, yearGregorian: e.target.value }))} placeholder="Year" />
                    </div>
                  ) : (
                    `${m.dayGregorian} ${m.monthGregorian} ${m.yearGregorian}`
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <div className="edit-group">
                      <input value={editForm.dayHijri} onChange={e => setEditForm(f => ({ ...f, dayHijri: e.target.value }))} placeholder="Day" />
                      <select
                        value={editForm.monthHijri || ""}
                        onChange={e => setEditForm(f => ({ ...f, monthHijri: e.target.value }))}
                        className="hijri-month-select-small"
                      >
                        <option value="">Month</option>
                        {HIJRI_MONTHS.map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                        ))}
                      </select>
                      <input value={editForm.yearHijri} onChange={e => setEditForm(f => ({ ...f, yearHijri: e.target.value }))} placeholder="Year" />
                    </div>
                  ) : (
                    `${m.dayHijri} ${m.monthHijri} ${m.yearHijri}`
                  )}
                </td>
                <td>{editIdx === idx ? <input value={editForm.dayNameEn} onChange={e => setEditForm(f => ({ ...f, dayNameEn: e.target.value }))} /> : m.dayNameEn}</td>
                <td>{editIdx === idx ? <input value={editForm.dayNameArabic} onChange={e => setEditForm(f => ({ ...f, dayNameArabic: e.target.value }))} /> : m.dayNameArabic}</td>
                <td>
                  {editIdx === idx ? (
                    <input
                      value={editForm.event || ""}
                      onChange={e => setEditForm(f => ({ ...f, event: e.target.value }))}
                      placeholder="Event"
                    />
                  ) : (
                    m.event || "-"
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <input
                      type="checkbox"
                      checked={editForm.isTentative || false}
                      onChange={e => setEditForm(f => ({ ...f, isTentative: e.target.checked }))}
                    />
                  ) : (
                    <span className={`tentative-badge ${m.isTentative ? 'tentative' : 'confirmed'}`}>
                      {m.isTentative ? 'Tentative' : 'Confirmed'}
                    </span>
                  )}
                </td>
                <td>
                  {editIdx === idx ? (
                    <>
                      <button className="primary" onClick={() => handleEditSave(idx)}>Save</button>
                      <button onClick={() => setEditIdx(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => handleEdit(m, idx)}>Edit</button>
                      <button className="danger" onClick={() => handleDelete(m)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ImportDataTab() {
  const [jsonResult, setJsonResult] = useState(null);
  const [error, setError] = useState("");
  const [isImporting, setIsImporting] = useState(false);
  const [importProgress, setImportProgress] = useState(0);
  const [importStatus, setImportStatus] = useState("");
  const [updateExisting, setUpdateExisting] = useState(false);

  function parseTime12to24(timeStr) {
    if (!timeStr) return { h: null, m: null };
    let [time, ampm] = timeStr.trim().split(/\s+/);
    let [h, m] = time.split(":").map(Number);
    if (ampm && ampm.toUpperCase() === "PM" && h !== 12) h += 12;
    if (ampm && ampm.toUpperCase() === "AM" && h === 12) h = 0;
    return { h, m };
  }

  function handleFile(e) {
    setError("");
    setJsonResult(null);
    const file = e.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        try {
          const data = results.data;
          const out = {};
          data.forEach(row => {
            const originalDate = row.DATE.trim();
            const country = row.COUNTRY.trim();
            const zone = row.ZONE.trim();
            if (!originalDate || !country || !zone) return;

            // Convert date from "YYYY-MM-DD", "DD-MM-YYYY", or "DD-MM-YY" to "DDMMYY"
            const dateParts = originalDate.split('-');
            if (dateParts.length === 3) {
              let day, month, year;

              if (dateParts[0].length === 4) { // YYYY-MM-DD
                year = dateParts[0].slice(-2);
                month = dateParts[1].padStart(2, '0');
                day = dateParts[2].padStart(2, '0');
              } else { // Assume DD-MM-YYYY or DD-MM-YY
                day = dateParts[0].padStart(2, '0');
                month = dateParts[1].padStart(2, '0');
                year = dateParts[2].slice(-2);
              }
              const date = `${day}${month}${year}`;

              if (!out[date]) out[date] = {};
              if (!out[date][country]) out[date][country] = {};
              out[date][country][zone] = {
                fajr: parseTime12to24(row.FAJR),
                sunrise: parseTime12to24(row.SUNRISE),
                luhar: parseTime12to24(row.LUHAR),
                asr: parseTime12to24(row.ASR),
                maghrib: parseTime12to24(row.MAGHRIB),
                isha: parseTime12to24(row.ISHA)
              };
            }
          });
          setJsonResult({ prayerTimes: out });
        } catch (err) {
          setError("Failed to parse CSV: " + err.message);
        }
      },
      error: (err) => setError("CSV Parse Error: " + err.message)
    });
  }

  const importToFirebase = async () => {
    if (!jsonResult || !jsonResult.prayerTimes) {
      setError("No data to import");
      return;
    }

    setIsImporting(true);
    setImportProgress(0);
    setImportStatus("Starting import...");
    setError("");

    try {
      const prayerTimes = jsonResult.prayerTimes;
      const dates = Object.keys(prayerTimes);
      const totalDates = dates.length;
      let processedDates = 0;

      for (const date of dates) {
        setImportStatus(`Importing date: ${date}...`);

        const dateData = prayerTimes[date];
        const countries = Object.keys(dateData);

        for (const country of countries) {
          const countryData = dateData[country];
          const zones = Object.keys(countryData);

          for (const zone of zones) {
            const zoneData = countryData[zone];

            // Check if data already exists
            const existingRef = ref(db, `prayerTimes/${date}/${country}/${zone}`);
            const snapshot = await get(existingRef);

            if (snapshot.exists()) {
              if (updateExisting) {
                // Update existing data
                await set(ref(db, `prayerTimes/${date}/${country}/${zone}`), zoneData);
                setImportStatus(`Updated existing data for ${date}/${country}/${zone}...`);
              } else {
                // Skip existing data
                setImportStatus(`Skipping existing data for ${date}/${country}/${zone}...`);
              }
            } else {
              // Import new data
              await set(ref(db, `prayerTimes/${date}/${country}/${zone}`), zoneData);
              setImportStatus(`Imported ${date}/${country}/${zone}...`);
            }
          }
        }

        processedDates++;
        const progress = Math.round((processedDates / totalDates) * 100);
        setImportProgress(progress);
      }

      setImportStatus("Import completed successfully!");
      setTimeout(() => {
        setIsImporting(false);
        setImportProgress(0);
        setImportStatus("");
      }, 2000);

    } catch (err) {
      setError("Import failed: " + err.message);
      setIsImporting(false);
      setImportProgress(0);
      setImportStatus("");
    }
  };

  return (
    <div>
      <h3>Import Prayer Times CSV</h3>
      <input type="file" accept=".csv" onChange={handleFile} />
      <div style={{ margin: "1rem 0" }}>
        <small>CSV header: COUNTRY,ZONE,DATE,FAJR,SUNRISE,LUHAR,ASR,MAGHRIB,ISHA</small>
        <small style={{ display: "block", marginTop: "0.25rem", color: "#666" }}>
          DATE format: YYYY-MM-DD, DD-MM-YYYY, or DD-MM-YY (e.g. 2026-06-11, 11-06-2026, 11-06-26)
        </small>
      </div>

      {/* Update Existing Records Checkbox */}
      <div style={{ margin: "1rem 0" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={updateExisting}
            onChange={(e) => setUpdateExisting(e.target.checked)}
            style={{ margin: 0 }}
          />
          <span>Update existing records</span>
        </label>
        <small style={{ display: "block", marginTop: "0.25rem", color: "#666" }}>
          {updateExisting
            ? "Existing records will be overwritten with new data from CSV"
            : "Existing records will be skipped (default safe behavior)"
          }
        </small>
      </div>
      {error && <div className="form-error">{error}</div>}
      {jsonResult && (
        <>
          <h4>Parsed JSON Preview</h4>
          <pre style={{ background: "#f7fafd", padding: 12, borderRadius: 8, maxHeight: 300, overflow: "auto", textAlign: "left" }}>
            {JSON.stringify(jsonResult, null, 2)}
          </pre>

          {isImporting ? (
            <div style={{ marginTop: 16 }}>
              <div style={{
                background: "#e5e7eb",
                borderRadius: 8,
                height: 20,
                overflow: "hidden",
                marginBottom: 8
              }}>
                <div style={{
                  background: "linear-gradient(90deg, #3b82f6, #1d4ed8)",
                  height: "100%",
                  width: `${importProgress}%`,
                  transition: "width 0.3s ease",
                  borderRadius: 8
                }} />
              </div>
              <div style={{
                fontSize: "0.9rem",
                color: "#6b7280",
                textAlign: "center",
                marginBottom: 8
              }}>
                {importProgress}% Complete
              </div>
              <div style={{
                fontSize: "0.85rem",
                color: "#374151",
                textAlign: "center",
                fontStyle: "italic"
              }}>
                {importStatus}
              </div>
            </div>
          ) : (
            <button
              className="primary"
              style={{ marginTop: 8 }}
              onClick={importToFirebase}
              disabled={isImporting}
            >
              Import to Firebase
            </button>
          )}
        </>
      )}
    </div>
  );
}

// ⚡ Bolt: Moved ADMIN_TABS array outside component to prevent reallocation on every render
const ADMIN_TABS = [
  { key: "prayer", label: "Manage Prayer Times" },
  { key: "zones", label: "Manage Zones" },
  { key: "areas", label: "Manage Areas" },
  { key: "meta", label: "Manage Meta Data" },
  { key: "import", label: "Import Data" },
];

function AdminPanel({ onLogout }) {
  const [tab, setTab] = useState("prayer");
  const [areas, setAreas] = useState([
    { key: "A1", name: "Colombo District" },
    { key: "A2", name: "Gampaha District" },
    { key: "A3", name: "Kalutara District" },
    { key: "A4", name: "Kandy District" },
  ]);

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <div className="admin-dashboard-title">Admin Dashboard</div>
        <div className="admin-tabs">
          {ADMIN_TABS.map(t => (
            <button
              key={t.key}
              className={tab === t.key ? "active" : ""}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="admin-tab-content">
        {tab === "prayer" && <ManagePrayerTimes />}
        {tab === "zones" && <ManageZones areas={areas} />}
        {tab === "areas" && <ManageAreas areas={areas} setAreas={setAreas} />}
        {tab === "meta" && <ManageMeta />}
        {tab === "import" && <ImportDataTab />}
      </div>
      <button className="admin-logout" onClick={onLogout}>Log Out</button>
      <Analytics />
    </div>
  );
}

function App() {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || "light";
  });
  const [timeFormat, setTimeFormat] = useState(() => {
    const savedTimeFormat = localStorage.getItem('timeFormat');
    return savedTimeFormat || "12h";
  });
  const [showLogin, setShowLogin] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [selectedArea, setSelectedArea] = useState(() => {
    const savedArea = localStorage.getItem('selectedArea');
    return savedArea || "";
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [prayerTimes, setPrayerTimes] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [layout, setLayout] = useState(() => {
    const savedLayout = localStorage.getItem('layout');
    return savedLayout || "vertical";
  });



  const handleLogin = (email, password) => {
    // Demo login: username 'demo', password 'demo123'
    if (email === "demo" && password === "demo123") {
      setIsAdmin(true);
      setShowLogin(false);
      setLoginError("");
    } else {
      setLoginError("Invalid credentials.");
    }
  };

  // Save theme preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Save time format preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('timeFormat', timeFormat);
  }, [timeFormat]);

  // Save layout preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('layout', layout);
  }, [layout]);

  const handleLogout = () => {
    setIsAdmin(false);
  };

  if (isAdmin) {
    return <AdminPanel onLogout={handleLogout} />;
  }

  return (
    <div className={`app-container ${theme}`}>
      <Header theme={theme} setTheme={setTheme} timeFormat={timeFormat} setTimeFormat={setTimeFormat} layout={layout} setLayout={setLayout} />
      <main>
        <PrayerTimesCard
          selectedArea={selectedArea}
          selectedDate={selectedDate}
          prayerTimes={prayerTimes}
          setPrayerTimes={setPrayerTimes}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setSelectedArea={setSelectedArea}
          setSelectedDate={setSelectedDate}
          timeFormat={timeFormat}
          layout={layout}
        />
        <UpNext
          selectedArea={selectedArea}
          selectedDate={selectedDate}
          prayerTimes={prayerTimes}
          isLoading={isLoading}
          timeFormat={timeFormat}
        />
        <HadithQuote />
        <HijriCalendar selectedDate={selectedDate} selectedArea={selectedArea} />
      </main>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-text">
              <div className="footer-title">Design & Development by Ziaul Hasan © 2025</div>
            </div>
            <div className="footer-icons">
              <button className="footer-icon" onClick={() => setShowLogin(true)} title="Admin Login">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <circle cx="12" cy="16" r="1"></circle>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </button>
              <button className="footer-icon" onClick={() => setShowContact(true)} title="Contact Developer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </footer>
      <FloatingShareButton />
      <FloatingQiblaButton />

      {showLogin && (
        <LoginPopup
          onClose={() => { setShowLogin(false); setLoginError(""); }}
          onLogin={handleLogin}
          error={loginError}
        />
      )}
      {showContact && (
        <ContactModal
          onClose={() => setShowContact(false)}
        />
      )}
      <Analytics />
    </div>
  );
}

export default App;
